import {
  Button,
  Container,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  Grid,
  IconButton,
  Stack,
  Step,
  StepLabel,
  Stepper,
  TextField,
  Typography
} from '@mui/material';
import FormControl from '@mui/material/FormControl';
import MenuItem from '@mui/material/MenuItem';
import Select from '@mui/material/Select';
import { Box } from '@mui/system';
import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';

// table component
// other component
// react icons
import { HiOutlineArrowNarrowLeft, HiOutlineArrowNarrowRight } from 'react-icons/hi';
// material icons
import CloseIcon from '@mui/icons-material/Close';
// other component
import BrudCrumbs from '../../components/BreadCrumbs';
import Page from '../../components/Page';
import PageTitle from '../../components/PageHeading';
import Loader from '../Global/Loader';
import { CommonApiforJourney } from '../services/RecommendationApi';
import RecommendationResult from '../Global/RecommendationResult';

import { recommendationResponse } from '../services/RecommendationApiResult';
import useLoginSelector from '../../store/Slice/Login/LoginSelector';

function LoanApplication() {
  const navigate = useNavigate();
  const [activeStep, setActiveStep] = React.useState(0);
  const [mutateState, setMutateState] = useState(null);
  const [popCommonState, setPopCommonState] = useState({ errorMessage: '', errorPopUp: false });
  const [errorHandling, setErrorHandling] = useState({ open: false, message: null });
  const [openLoader, setOpenLoader] = useState(false);

  const [getrecomdationDataList, setGetrecomdationDataList] = useState([]);
  const [recommendationState, setRecommendationState] = useState({
    loanDetails: {
      name: null,
      mobile: null,
      email: null,
      employmentType: ' ',
      employment_type_id: null,
      employmentTypeArray: [],
      employmentSubType: ' ',
      employment_sub_type_id: null,
      employmentSubTypeArray: [],
      loanType: ' ',
      loan_type_id: null,
      loanTypeArray: [],
      loanSubType: ' ',
      loan_sub_type_id: null,
      loanSubTypeArray: [],
      loan_amount: null,
      loan_tenure: null
    },
    customerDetails: {
      dateOfBirth: null,
      pan_number: null,
      aadharNumber: null,
      gender: ' ',
      gender_type_id: null,
      genderArray: [],
      maritalStatus: ' ',
      maritalstatus_type_id: null,
      maritalStatusArray: [],
      gst_number: null,
      location: null,
      totalworkexperienceinmonths: null,
      noOfMonthsInCurrentJob: null,
      totalJobContinuityInMonths: null,

      dataOfIncorporation: null,
      officeLocationPincode: null,
      businessProofRequired: ' ',
      yearlyTurnover: null,
      yearlyNetProfit: null,
      yearlyDepreciation: null,
      yearlyInterest: null,
      companyName: null,
      typeOfOrganization: ' ',
      typeOfOrganizationId: null,
      typeOfOrganizationArray: [],
      typeOfSalary: ' ',
      typeOfSalaryId: null,
      typeOfSalaryArray: [],
      grossSalaryPerAnnum: null,
      monthlySalaryNetTakeHome: null,
      monthlyIncentiveBonusIncome: null,
      monthlyCashIncome: null,
      monthlyRentalIncome: null,
      monthlyInterestIncome: null,
      otherIncomeMonthly: null,
      totalNoOfLoans: null,
      totalMonthlyInstallments: null,
      customerCreditScore: null,
      companyCreditScore: null,
      typeOfProperty: ' ',
      typeOfPropertyId: null,
      typeOfPropertyArray: [],
      typeofOwnership: ' ',
      typeofOwnershipId: null,
      typeofOwnershipArray: [],
      stageofConstruction: ' ',
      stageofConstructionId: null,
      stageofConstructionArray: [],
      propertyAge: null,
      locationtypeOfProperty: ' ',
      locationtypeOfPropertyId: null,
      locationtypeOfPropertyArray: [],
      typeOfPurchase: ' ',
      typeOfPurchaseId: null,
      typeOfPurchaseArray: [],
      projectApprovalStatus: ' ',
      nameOfBuilder: null,
      nameOfApprovedBanks: null,
      propertyAddress: null,
      pinCode: null,
      locality: null,
      city: ' ',
      cityId: null,
      cityArray: [],
      district: null,
      state: ' ',
      stateId: null,
      stateArray: [],
      acres: null,
      magicBricksValue: null,
      makaanComValuation: null,
      housing: null,
      registarDataValuation: null,
      propertyValue2: null
    },
    coApplicantDetails: {
      coApplicantEmploymentType: ' ',
      coApplicantEmploymentTypeId: null,
      coApplicantEmploymentTypeArray: [],
      coApplicantEmploymentSubType: ' ',
      coApplicantEmploymentSubTypeId: null,
      coApplicantEmploymentSubTypeArray: [],
      yearlyTurnover: null,
      yearlyNetProfit: null,
      yearlyDepreciation: null,
      yearlyInterest: null,
      typeOfSalary: ' ',
      typeOfSalaryId: null,
      typeOfSalaryArray: [],
      grossSalaryPerAnnum: null,
      monthlySalaryNetTakeHome: null,
      monthlyIncentiveBonusIncome: null,
      monthlyCashIncome: null,
      monthlyRentalIncome: null,
      monthlyInterestIncome: null,
      otherIncomeMonthly: null,
      totalNoOfLoans: null,
      totalMonthlyInstallments: null,
      coApplicantCompanyCreditScore: null,
      coApplicantCreditScore: null,
      coapplicantJobContinuity: null,
      coApplicantDateOfBirth: null
    }
  });

  useEffect(() => {
    recommendationApiFire('loanType', null);
    recommendationApiFire('employmentType', null);
    recommendationApiFire('stateList', null);
    recommendationApiFire('genderList', null);
    recommendationApiFire('maritalList', null);
    recommendationApiFire('organizationList', null);
    recommendationApiFire('ownershipList', null);
    recommendationApiFire('propertyList', null);
    recommendationApiFire('constructionList', null);
    recommendationApiFire('purchaseList', null);
    recommendationApiFire('salaryList', null);
    recommendationApiFire('propertylocationList', null);
  }, []);

  const { LoginData } = useLoginSelector();

  useEffect(() => {
    const viewRecommendation = JSON.parse(localStorage.getItem(`viewRecommendation`));
    if (viewRecommendation !== null) {
      recommendationApiFire('editRecommendation', viewRecommendation.recommendationId);
    }
  }, []);

  useEffect(() => {
    console.log('recommendationStaterecommendationState', recommendationState);
  }, [recommendationState]);

  const handleNextBackFinish = (type) => {
    if (type === 'finish') {
      setErrorHandling({ open: true, message: 'Recommendation Saved Successfully' });
      if (errorHandling.open === false) {
        navigate('/leads');
        localStorage.setItem('fromRecommendationTab', 'active');
      }
    } else if (type === 'onlyNext') {
      setActiveStep((activeStep) => activeStep + 1);
    } else {
      setActiveStep((activeStep) => activeStep - 1);
    }
  };

  const recommendationApiFire = async (type, condition) => {
    const companyIdObj = {
      companyId: LoginData?.companyId,
      userId: LoginData?.userId
    };
    let methodName = '';
    let endapiPath = '';
    const token = LoginData?.jwt;

    if (type === 'loanType') {
      companyIdObj.returnConfiguredTypesOnly = true;
      methodName = 'POST';
      endapiPath = 'company/parent-loan-masters/list';
    } else if (type === 'loanSubType') {
      if (condition !== null) {
        companyIdObj.parentLoanId = condition;
        companyIdObj.returnConfiguredTypesOnly = true;
        methodName = 'POST';
        endapiPath = 'company/loan-masters/list';
      }
    } else if (type === 'employmentType') {
      companyIdObj.returnConfiguredTypesOnly = true;
      methodName = 'POST';
      endapiPath = 'company/parent-emp-types/list';
    } else if (type === 'employmentSubType') {
      if (condition !== null) {
        companyIdObj.returnConfiguredTypesOnly = true;
        companyIdObj.employmentCategoryId = condition;
        methodName = 'POST';
        endapiPath = 'company/emp-types/list';
      }
    } else if (type === 'stateList') {
      companyIdObj.searchLiteral = '';
      companyIdObj.countryId = 101;
      methodName = 'POST';
      endapiPath = 'sa/cscs/state/list';
    } else if (type === 'cityList') {
      companyIdObj.searchLiteral = '';
      companyIdObj.stateId = condition;
      methodName = 'POST';
      endapiPath = 'sa/cscs/city/list';
    } else if (type === 'genderList') {
      methodName = 'GET';
      endapiPath = 'common/master-list/GENDER_TYPE';
    } else if (type === 'maritalList') {
      methodName = 'GET';
      endapiPath = 'common/master-list/MARITAL_STATUS_TYPE';
    } else if (type === 'organizationList') {
      methodName = 'GET';
      endapiPath = 'common/master-list/ORGANIZATION_TYPE';
    } else if (type === 'ownershipList') {
      methodName = 'GET';
      endapiPath = 'common/master-list/OWNERSHIP_TYPE';
    } else if (type === 'propertyList') {
      methodName = 'GET';
      endapiPath = 'common/master-list/PROPERTY_TYPE';
    } else if (type === 'constructionList') {
      methodName = 'GET';
      endapiPath = 'common/master-list/CONSTRUCTION_STAGE_TYPE';
    } else if (type === 'purchaseList') {
      methodName = 'GET';
      endapiPath = 'common/master-list/PURCHASE_TYPE';
    } else if (type === 'salaryList') {
      methodName = 'GET';
      endapiPath = 'common/master-list/SALARY_TYPE';
    } else if (type === 'propertylocationList') {
      methodName = 'GET';
      endapiPath = 'common/master-list/PROPERTY_LOCATION_TYPE';
    } else if (type === 'saveRecommendation') {
      if (recommendationState.loanDetails.email !== null) {
        const mailformat = /^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/;
        if (!mailformat.test(recommendationState.loanDetails.email)) {
          setPopCommonState({
            errorMessage: 'Enter Valid Email Id',
            errorPopUp: true
          });
          return false;
        } else {
          const viewRecommendation = JSON.parse(localStorage.getItem(`viewRecommendation`));
          let triggerVal = false;
          if (activeStep === 2) {
            triggerVal = true;
          }
          companyIdObj.triggerRecommendationCalculation = triggerVal;
          companyIdObj.recommendation = {
            partnerRecommendationId:
              viewRecommendation !== null ? Number(viewRecommendation.recommendationId) : null,
            name: recommendationState.loanDetails.name,
            mobile: Number(recommendationState.loanDetails.mobile),
            isMobileVerified: false,
            email: recommendationState.loanDetails.email,
            isEmailVerified: false,
            employmentTypeId:
              recommendationState.loanDetails.employment_type_id !== null
                ? Number(recommendationState.loanDetails.employment_type_id)
                : null,
            employmentSubTypeId:
              recommendationState.loanDetails.employment_sub_type_id !== null
                ? Number(recommendationState.loanDetails.employment_sub_type_id)
                : null,
            loanTypeId:
              recommendationState.loanDetails.loan_type_id !== null
                ? Number(recommendationState.loanDetails.loan_type_id)
                : null,
            loanSubTypeId:
              recommendationState.loanDetails.loan_sub_type_id !== null
                ? Number(recommendationState.loanDetails.loan_sub_type_id)
                : null,
            loanAmount:
              recommendationState.loanDetails.loan_amount !== null
                ? Number(recommendationState.loanDetails.loan_amount)
                : null,
            loanTenure:
              recommendationState.loanDetails.loan_tenure !== null
                ? Number(recommendationState.loanDetails.loan_tenure)
                : null,
            coApplicantCreditScore:
              recommendationState.coApplicantDetails.coApplicantCreditScore !== null
                ? Number(recommendationState.coApplicantDetails.coApplicantCreditScore)
                : null,
            coApplicantEmploymentSubTypeId:
              recommendationState.coApplicantDetails.coApplicantEmploymentSubTypeId !== null
                ? Number(recommendationState.coApplicantDetails.coApplicantEmploymentSubTypeId)
                : null,
            coApplicantEmploymentTypeId:
              recommendationState.coApplicantDetails.coApplicantEmploymentTypeId !== null
                ? Number(recommendationState.coApplicantDetails.coApplicantEmploymentTypeId)
                : null,
            coApplicantCompanyCreditScore:
              recommendationState.coApplicantDetails.coApplicantCompanyCreditScore !== null
                ? Number(recommendationState.coApplicantDetails.coApplicantCompanyCreditScore)
                : null,

            coApplicantGrossSalaryPerAnnum:
              recommendationState.coApplicantDetails.grossSalaryPerAnnum !== null
                ? Number(recommendationState.coApplicantDetails.grossSalaryPerAnnum)
                : null,
            coApplicantMonthlyCashIncome:
              recommendationState.coApplicantDetails.monthlyCashIncome !== null
                ? Number(recommendationState.coApplicantDetails.monthlyCashIncome)
                : null,
            coApplicantMonthlyIncentiveBonusIncome:
              recommendationState.coApplicantDetails.monthlyIncentiveBonusIncome !== null
                ? Number(recommendationState.coApplicantDetails.monthlyIncentiveBonusIncome)
                : null,
            coApplicantMonthlyRentalIncome:
              recommendationState.coApplicantDetails.monthlyRentalIncome !== null
                ? Number(recommendationState.coApplicantDetails.monthlyRentalIncome)
                : null,
            coApplicantMonthlySalaryNetTakeHome:
              recommendationState.coApplicantDetails.monthlySalaryNetTakeHome !== null
                ? Number(recommendationState.coApplicantDetails.monthlySalaryNetTakeHome)
                : null,
            coApplicantOtherIncomeMonthly:
              recommendationState.coApplicantDetails.otherIncomeMonthly !== null
                ? Number(recommendationState.coApplicantDetails.otherIncomeMonthly)
                : null,
            aadharNumber:
              recommendationState.customerDetails.aadharNumber !== null
                ? recommendationState.customerDetails.aadharNumber
                : null,

            customerCreditScore:
              recommendationState.customerDetails.customerCreditScore !== null
                ? Number(recommendationState.customerDetails.customerCreditScore)
                : null,

            companyCreditScore:
              recommendationState.customerDetails.companyCreditScore !== null
                ? Number(recommendationState.customerDetails.companyCreditScore)
                : null,

            cityId:
              recommendationState.customerDetails.cityId !== null
                ? Number(recommendationState.customerDetails.cityId)
                : null,
            constructionStageId:
              recommendationState.customerDetails.stageofConstructionId !== null
                ? Number(recommendationState.customerDetails.stageofConstructionId)
                : null,
            dataOfIncorporation:
              recommendationState.customerDetails.dataOfIncorporation !== null
                ? recommendationState.customerDetails.dataOfIncorporation
                : null,
            dateOfBirth:
              recommendationState.customerDetails.dateOfBirth !== null
                ? recommendationState.customerDetails.dateOfBirth
                : null,
            district:
              recommendationState.customerDetails.district !== null
                ? recommendationState.customerDetails.district
                : null,
            genderTypeId:
              recommendationState.customerDetails.gender_type_id !== null
                ? Number(recommendationState.customerDetails.gender_type_id)
                : null,
            gstNumber:
              recommendationState.customerDetails.gst_number !== null
                ? recommendationState.customerDetails.gst_number
                : null,
            stateId:
              recommendationState.customerDetails.stateId !== null
                ? Number(recommendationState.customerDetails.stateId)
                : null,
            location:
              recommendationState.customerDetails.location !== null
                ? recommendationState.customerDetails.location
                : null,
            magicBricksValue:
              recommendationState.customerDetails.magicBricksValue !== null
                ? Number(recommendationState.customerDetails.magicBricksValue)
                : null,
            makaanComValuation:
              recommendationState.customerDetails.makaanComValuation !== null
                ? Number(recommendationState.customerDetails.makaanComValuation)
                : null,
            maritalStatusTypeId:
              recommendationState.customerDetails.maritalstatus_type_id !== null
                ? Number(recommendationState.customerDetails.maritalstatus_type_id)
                : null,
            nameOfApprovedBanks:
              recommendationState.customerDetails.nameOfApprovedBanks !== null
                ? recommendationState.customerDetails.nameOfApprovedBanks
                : null,
            nameOfBuilder:
              recommendationState.customerDetails.nameOfBuilder !== null
                ? recommendationState.customerDetails.nameOfBuilder
                : null,
            noOfMonthsInCurrentJob:
              recommendationState.customerDetails.noOfMonthsInCurrentJob !== null
                ? Number(recommendationState.customerDetails.noOfMonthsInCurrentJob)
                : null,
            officeLocationPincode:
              recommendationState.customerDetails.officeLocationPincode !== null
                ? recommendationState.customerDetails.officeLocationPincode
                : null,
            panNumber:
              recommendationState.customerDetails.pan_number !== null
                ? recommendationState.customerDetails.pan_number
                : null,
            propertyValue2:
              recommendationState.customerDetails.propertyValue2 !== null
                ? Number(recommendationState.customerDetails.propertyValue2)
                : null,
            purchaseTypeId:
              recommendationState.customerDetails.typeOfPurchaseId !== null
                ? Number(recommendationState.customerDetails.typeOfPurchaseId)
                : null,
            registarDataValuation:
              recommendationState.customerDetails.registarDataValuation !== null
                ? Number(recommendationState.customerDetails.registarDataValuation)
                : null,
            totalJobContinuityInMonths:
              recommendationState.customerDetails.totalJobContinuityInMonths !== null
                ? Number(recommendationState.customerDetails.totalJobContinuityInMonths)
                : null,
            totalWorkExperienceInMonths:
              recommendationState.customerDetails.totalworkexperienceinmonths !== null
                ? Number(recommendationState.customerDetails.totalworkexperienceinmonths)
                : null,
            yearlyDepreciation:
              recommendationState.customerDetails.yearlyDepreciation !== null
                ? Number(recommendationState.customerDetails.yearlyDepreciation)
                : null,
            yearlyInterest:
              recommendationState.customerDetails.yearlyInterest !== null
                ? Number(recommendationState.customerDetails.yearlyInterest)
                : null,
            yearlyNetProfit:
              recommendationState.customerDetails.yearlyNetProfit !== null
                ? Number(recommendationState.customerDetails.yearlyNetProfit)
                : null,
            yearlyTurnover:
              recommendationState.customerDetails.yearlyTurnover !== null
                ? Number(recommendationState.customerDetails.yearlyTurnover)
                : null,
            companyName:
              recommendationState.customerDetails.companyName !== null
                ? recommendationState.customerDetails.companyName
                : null,
            totalMonthlyInstallments:
              recommendationState.customerDetails.totalMonthlyInstallments !== null
                ? Number(recommendationState.customerDetails.totalMonthlyInstallments)
                : null,

            coapplicantJobContinuity:
              recommendationState.coApplicantDetails.coapplicantJobContinuity !== null
                ? Number(recommendationState.coApplicantDetails.coapplicantJobContinuity)
                : null,

            coApplicantDateOfBirth:
              recommendationState.coApplicantDetails.coApplicantDateOfBirth !== null
                ? recommendationState.coApplicantDetails.coApplicantDateOfBirth
                : null,

            coApplicantSalaryTypeId:
              recommendationState.coApplicantDetails.typeOfSalaryId !== null
                ? Number(recommendationState.coApplicantDetails.typeOfSalaryId)
                : null,
            coApplicantTotalMonthlyInstalments:
              recommendationState.coApplicantDetails.totalMonthlyInstallments !== null
                ? Number(recommendationState.coApplicantDetails.totalMonthlyInstallments)
                : null,
            coApplicantYearlyDepreciation:
              recommendationState.coApplicantDetails.yearlyDepreciation !== null
                ? Number(recommendationState.coApplicantDetails.yearlyDepreciation)
                : null,
            coApplicantYearlyNetProfit:
              recommendationState.coApplicantDetails.yearlyNetProfit !== null
                ? Number(recommendationState.coApplicantDetails.yearlyNetProfit)
                : null,
            coApplicantYearlyTurnover:
              recommendationState.coApplicantDetails.yearlyTurnover !== null
                ? Number(recommendationState.coApplicantDetails.yearlyTurnover)
                : null,
            coApplicantYearlyInterest:
              recommendationState.coApplicantDetails.yearlyInterest !== null
                ? Number(recommendationState.coApplicantDetails.yearlyInterest)
                : null,
            coApplicantMonthlyInterestIncome:
              recommendationState.coApplicantDetails.monthlyInterestIncome !== null
                ? Number(recommendationState.coApplicantDetails.monthlyInterestIncome)
                : null,
            coApplicantTotalNoOfLoans:
              recommendationState.coApplicantDetails.totalNoOfLoans !== null
                ? Number(recommendationState.coApplicantDetails.totalNoOfLoans)
                : null,
            totalNoOfLoans:
              recommendationState.customerDetails.yearlyNetProfit !== null
                ? Number(recommendationState.customerDetails.yearlyNetProfit)
                : null,
            otherIncomeMonthly:
              recommendationState.customerDetails.otherIncomeMonthly !== null
                ? Number(recommendationState.customerDetails.otherIncomeMonthly)
                : null,
            monthlyInterestIncome:
              recommendationState.customerDetails.monthlyInterestIncome !== null
                ? Number(recommendationState.customerDetails.monthlyInterestIncome)
                : null,
            monthlyRentalIncome:
              recommendationState.customerDetails.monthlyRentalIncome !== null
                ? Number(recommendationState.customerDetails.monthlyRentalIncome)
                : null,
            monthlyCashIncome:
              recommendationState.customerDetails.monthlyCashIncome !== null
                ? Number(recommendationState.customerDetails.monthlyCashIncome)
                : null,
            monthlyIncentiveBonusIncome:
              recommendationState.customerDetails.monthlyIncentiveBonusIncome !== null
                ? Number(recommendationState.customerDetails.monthlyIncentiveBonusIncome)
                : null,
            monthlySalaryNetTakeHome:
              recommendationState.customerDetails.monthlySalaryNetTakeHome !== null
                ? Number(recommendationState.customerDetails.monthlySalaryNetTakeHome)
                : null,
            grossSalaryPerAnnum:
              recommendationState.customerDetails.grossSalaryPerAnnum !== null
                ? Number(recommendationState.customerDetails.grossSalaryPerAnnum)
                : null,
            propertyAddress:
              recommendationState.customerDetails.propertyAddress !== null
                ? recommendationState.customerDetails.propertyAddress
                : null,
            propertyAge:
              recommendationState.customerDetails.propertyAge !== null
                ? recommendationState.customerDetails.propertyAge
                : null,
            propertyTypeId:
              recommendationState.customerDetails.typeOfPropertyId !== null
                ? Number(recommendationState.customerDetails.typeOfPropertyId)
                : null,
            ninetynineAcresValue:
              recommendationState.customerDetails.acres !== null
                ? Number(recommendationState.customerDetails.acres)
                : null,
            organisationTypeId:
              recommendationState.customerDetails.typeOfOrganizationId !== null
                ? Number(recommendationState.customerDetails.typeOfOrganizationId)
                : null,
            ownershipTypeId:
              recommendationState.customerDetails.typeofOwnershipId !== null
                ? Number(recommendationState.customerDetails.typeofOwnershipId)
                : null,
            projectApprovalStatusId:
              recommendationState.customerDetails.projectApprovalStatus !== null
                ? recommendationState.customerDetails.projectApprovalStatus === 'Yes'
                  ? true
                  : false
                : null,
            businessProofRequired:
              recommendationState.customerDetails.businessProofRequired !== null
                ? recommendationState.customerDetails.businessProofRequired === 'Yes'
                  ? true
                  : false
                : null,
            locationTypeOfProperty:
              recommendationState.customerDetails.locationTypeOfProperty !== null
                ? recommendationState.customerDetails.locationTypeOfProperty
                : null,
            housingValue:
              recommendationState.customerDetails.housing !== null
                ? Number(recommendationState.customerDetails.housing)
                : null,
            propertyLocality:
              recommendationState.customerDetails.locationtypeOfPropertyId !== null
                ? recommendationState.customerDetails.locationtypeOfPropertyId
                : null,
            propertyPinCode:
              recommendationState.customerDetails.pinCode !== null
                ? recommendationState.customerDetails.pinCode
                : null
          };

          methodName = 'POST';
          endapiPath = 'recommendation/create';
        }
      }
    } else if (type === 'editRecommendation') {
      methodName = 'GET';
      endapiPath = `recommendation/view/${condition}`;
    }

    recommendationApiFireResponse(
      type,
      methodName,
      endapiPath,
      JSON.stringify(companyIdObj),
      token,
      ''
    );
  };

  const recommendationApiFireResponse = async (
    type,
    method,
    endpoint,
    credentials,
    authToken,
    frmData
  ) => {
    setOpenLoader(true);
    const responseData = await CommonApiforJourney(
      method,
      endpoint,
      credentials,
      authToken,
      frmData
    );
    if (responseData.status === 'success' || responseData.action_status === 'success') {
      setOpenLoader(false);
      if (type === 'loanType') {
        const prevData = recommendationState.loanDetails;
        prevData.loanTypeArray = responseData.data.loanMasters;
        setRecommendationState({ ...recommendationState, loanDetails: prevData });
      } else if (type === 'loanSubType') {
        const prevData = recommendationState.loanDetails;
        prevData.loanSubTypeArray = responseData.data.loanTypes;
        setRecommendationState({ ...recommendationState, loanDetails: prevData });
      } else if (type === 'employmentType') {
        const prevData = recommendationState.loanDetails;
        prevData.employmentTypeArray = responseData.data.empTypes;
        recommendationState.coApplicantDetails.coApplicantEmploymentTypeArray =
          responseData.data.empTypes;
        setRecommendationState({ ...recommendationState, loanDetails: prevData });
      } else if (type === 'employmentSubType') {
        const prevData = recommendationState.loanDetails;
        console.log('prevDatamx', prevData);
        prevData.employmentSubTypeArray = responseData.data.subEmpTypes;
        recommendationState.coApplicantDetails.coApplicantEmploymentSubTypeArray =
          responseData.data.subEmpTypes;
        setRecommendationState({ ...recommendationState, loanDetails: prevData });
      } else if (type === 'stateList') {
        console.log('seeeee', responseData);
        const prevData = recommendationState.customerDetails;
        prevData.stateArray = responseData.data;
        setRecommendationState({ ...recommendationState, customerDetails: prevData });
      } else if (type === 'cityList') {
        const prevData = recommendationState.customerDetails;
        prevData.cityArray = responseData.data;
        setRecommendationState({ ...recommendationState, customerDetails: prevData });
      } else if (type === 'genderList') {
        const prevData = recommendationState.customerDetails;
        prevData.genderArray = responseData.data.masterTypes;
        setRecommendationState({ ...recommendationState, customerDetails: prevData });
      } else if (type === 'maritalList') {
        const prevData = recommendationState.customerDetails;
        prevData.maritalStatusArray = responseData.data.masterTypes;
        setRecommendationState({ ...recommendationState, customerDetails: prevData });
      } else if (type === 'organizationList') {
        const prevData = recommendationState.customerDetails;
        prevData.typeOfOrganizationArray = responseData.data.masterTypes;
        setRecommendationState({ ...recommendationState, customerDetails: prevData });
      } else if (type === 'ownershipList') {
        const prevData = recommendationState.customerDetails;
        prevData.typeofOwnershipArray = responseData.data.masterTypes;
        setRecommendationState({ ...recommendationState, customerDetails: prevData });
      } else if (type === 'propertyList') {
        const prevData = recommendationState.customerDetails;
        prevData.typeOfPropertyArray = responseData.data.masterTypes;
        setRecommendationState({ ...recommendationState, customerDetails: prevData });
      } else if (type === 'constructionList') {
        const prevData = recommendationState.customerDetails;
        prevData.stageofConstructionArray = responseData.data.masterTypes;
        setRecommendationState({ ...recommendationState, customerDetails: prevData });
      } else if (type === 'purchaseList') {
        const prevData = recommendationState.customerDetails;
        prevData.typeOfPurchaseArray = responseData.data.masterTypes;
        setRecommendationState({ ...recommendationState, customerDetails: prevData });
      } else if (type === 'salaryList') {
        const prevData = recommendationState.customerDetails;
        prevData.typeOfSalaryArray = responseData.data.masterTypes;
        recommendationState.coApplicantDetails.typeOfSalaryArray = responseData.data.masterTypes;
        setRecommendationState({ ...recommendationState, customerDetails: prevData });
      } else if (type === 'propertylocationList') {
        const prevData = recommendationState.customerDetails;
        prevData.locationtypeOfPropertyArray = responseData.data.masterTypes;
        setRecommendationState({ ...recommendationState, customerDetails: prevData });
      } else if (type === 'saveRecommendation') {
        const obj = {
          recommendationId: responseData.data.updatedRecommendation.partnerRecommendationId
        };
        localStorage.setItem('viewRecommendation', JSON.stringify(obj));
        if (activeStep === 2) {
          const getrecomdationData = await recommendationResponse();
          setGetrecomdationDataList(getrecomdationData);
          handleNextBackFinish('onlyNext');
        } else {
          handleNextBackFinish('onlyNext');
        }
      } else if (type === 'editRecommendation') {
        const prevData = recommendationState;
        prevData.loanDetails = {
          name: responseData.data.recommendation.name,
          mobile: responseData.data.recommendation.mobile,
          email: responseData.data.recommendation.email,
          employmentType:
            responseData.data.recommendation.empType !== null
              ? JSON.stringify(responseData.data.recommendation.empType)
              : ' ',
          employment_type_id: responseData.data.recommendation.employmentTypeId,
          employmentTypeArray: recommendationState.loanDetails.employmentTypeArray,
          employmentSubType:
            responseData.data.recommendation.empSubType !== null
              ? JSON.stringify(responseData.data.recommendation.empSubType)
              : ' ',
          employment_sub_type_id: responseData.data.recommendation.employmentSubTypeId,
          employmentSubTypeArray: recommendationState.loanDetails.employmentSubTypeArray,
          loanType:
            responseData.data.recommendation.loanType !== null
              ? JSON.stringify(responseData.data.recommendation.loanType)
              : ' ',
          loan_type_id: responseData.data.recommendation.loanTypeId,
          loanTypeArray: recommendationState.loanDetails.loanTypeArray,
          loanSubType:
            responseData.data.recommendation.loanSubType !== null
              ? JSON.stringify(responseData.data.recommendation.loanSubType)
              : ' ',
          loan_sub_type_id: responseData.data.recommendation.loanSubTypeId,
          loanSubTypeArray: recommendationState.loanDetails.loanSubTypeArray,
          loan_amount: responseData.data.recommendation.loanAmount,
          loan_tenure: responseData.data.recommendation.loanTenure
        };
        prevData.customerDetails = {
          dateOfBirth: responseData.data.recommendation.dateOfBirth,
          pan_number: responseData.data.recommendation.panNumber,
          aadharNumber: responseData.data.recommendation.aadharNumber,
          gender:
            responseData.data.recommendation.gender !== null
              ? JSON.stringify(responseData.data.recommendation.gender)
              : ' ',
          gender_type_id: responseData.data.recommendation.genderTypeId,
          genderArray: recommendationState.customerDetails.genderArray,
          maritalStatus:
            responseData.data.recommendation.maritalStatus !== null
              ? JSON.stringify(responseData.data.recommendation.maritalStatus)
              : ' ',
          maritalstatus_type_id: responseData.data.recommendation.maritalStatusTypeId,
          maritalStatusArray: recommendationState.customerDetails.maritalStatusArray,
          gst_number: responseData.data.recommendation.gstNumber,
          location: responseData.data.recommendation.location,
          totalworkexperienceinmonths: responseData.data.recommendation.totalWorkExperienceInMonths,
          noOfMonthsInCurrentJob: responseData.data.recommendation.noOfMonthsInCurrentJob,
          totalJobContinuityInMonths: responseData.data.recommendation.totalJobContinuityInMonths,
          dataOfIncorporation: responseData.data.recommendation.dataOfIncorporation,
          officeLocationPincode: responseData.data.recommendation.officeLocationPincode,
          yearlyTurnover: responseData.data.recommendation.yearlyTurnover,
          yearlyNetProfit: responseData.data.recommendation.yearlyNetProfit,
          yearlyDepreciation: responseData.data.recommendation.yearlyDepreciation,
          yearlyInterest: responseData.data.recommendation.yearlyInterest,
          companyName: responseData.data.recommendation.companyName,
          typeOfOrganization:
            responseData.data.recommendation.organisationType !== null
              ? JSON.stringify(responseData.data.recommendation.organisationType)
              : ' ',
          typeOfOrganizationId: responseData.data.recommendation.organisationTypeId,
          typeOfOrganizationArray: recommendationState.customerDetails.typeOfOrganizationArray,

          typeOfSalary:
            responseData.data.recommendation.salaryType !== null
              ? JSON.stringify(responseData.data.recommendation.salaryType)
              : ' ',
          typeOfSalaryId: responseData.data.recommendation.salaryTypeId,
          typeOfSalaryArray: recommendationState.customerDetails.typeOfSalaryArray,

          grossSalaryPerAnnum: responseData.data.recommendation.grossSalaryPerAnnum,
          monthlySalaryNetTakeHome: responseData.data.recommendation.monthlySalaryNetTakeHome,
          monthlyIncentiveBonusIncome: responseData.data.recommendation.monthlyIncentiveBonusIncome,
          monthlyCashIncome: responseData.data.recommendation.monthlyCashIncome,
          monthlyRentalIncome: responseData.data.recommendation.monthlyRentalIncome,
          monthlyInterestIncome: responseData.data.recommendation.monthlyInterestIncome,
          otherIncomeMonthly: responseData.data.recommendation.otherIncomeMonthly,
          totalNoOfLoans: responseData.data.recommendation.totalNoOfLoans,
          totalMonthlyInstallments: responseData.data.recommendation.totalMonthlyInstallments,

          typeOfProperty:
            responseData.data.recommendation.propertyType !== null
              ? JSON.stringify(responseData.data.recommendation.propertyType)
              : ' ',
          typeOfPropertyId: responseData.data.recommendation.propertyTypeId,
          typeOfPropertyArray: recommendationState.customerDetails.typeOfPropertyArray,

          typeofOwnership:
            responseData.data.recommendation.ownershipType !== null
              ? JSON.stringify(responseData.data.recommendation.ownershipType)
              : ' ',
          typeofOwnershipId: responseData.data.recommendation.ownershipTypeId,
          typeofOwnershipArray: recommendationState.customerDetails.typeofOwnershipArray,

          stageofConstruction:
            responseData.data.recommendation.constructionStage !== null
              ? JSON.stringify(responseData.data.recommendation.constructionStage)
              : ' ',
          stageofConstructionId: responseData.data.recommendation.constructionStageId,
          stageofConstructionArray: recommendationState.customerDetails.stageofConstructionArray,

          propertyAge: responseData.data.recommendation.propertyAge,

          locationtypeOfProperty:
            responseData.data.recommendation.locationTypeOfProperty !== null
              ? JSON.stringify(responseData.data.recommendation.locationTypeOfProperty)
              : ' ',
          locationtypeOfPropertyId: responseData.data.recommendation.locationTypeOfPropertyId,
          locationtypeOfPropertyArray:
            recommendationState.customerDetails.locationtypeOfPropertyArray,

          typeOfPurchase:
            responseData.data.recommendation.purchaseType !== null
              ? JSON.stringify(responseData.data.recommendation.purchaseType)
              : ' ',
          typeOfPurchaseId: responseData.data.recommendation.purchaseTypeId,
          typeOfPurchaseArray: recommendationState.customerDetails.typeOfPurchaseArray,
          pinCode: responseData.data.recommendation.propertyPinCode,

          projectApprovalStatus:
            responseData.data.recommendation.projectApprovalStatusId !== null
              ? responseData.data.recommendation.projectApprovalStatusId === true
                ? 'Yes'
                : 'No'
              : ' ',

          businessProofRequired:
            responseData.data.recommendation.businessProofRequired !== null
              ? responseData.data.recommendation.businessProofRequired === true
                ? 'Yes'
                : 'No'
              : ' ',

          customerCreditScore: responseData.data.recommendation.customerCreditScore,
          companyCreditScore: responseData.data.recommendation.companyCreditScore,

          nameOfBuilder: responseData.data.recommendation.nameOfBuilder,
          nameOfApprovedBanks: responseData.data.recommendation.nameOfApprovedBanks,
          propertyAddress: responseData.data.recommendation.propertyAddress,
          locality: responseData.data.recommendation.propertyLocality,
          city:
            responseData.data.recommendation.city !== null
              ? JSON.stringify(responseData.data.recommendation.city)
              : ' ',
          cityId: responseData.data.recommendation.cityId,
          cityArray: recommendationState.customerDetails.cityArray,

          district: responseData.data.recommendation.district,
          state:
            responseData.data.recommendation.state !== null
              ? JSON.stringify(responseData.data.recommendation.state)
              : ' ',
          stateId: responseData.data.recommendation.stateId,
          stateArray: recommendationState.customerDetails.stateArray,

          acres: responseData.data.recommendation.ninetynineAcresValue,
          magicBricksValue: responseData.data.recommendation.magicBricksValue,
          makaanComValuation: responseData.data.recommendation.makaanComValuation,
          housing: responseData.data.recommendation.housingValue,
          registarDataValuation: responseData.data.recommendation.registarDataValuation,
          propertyValue2: responseData.data.recommendation.propertyValue2
        };
        prevData.coApplicantDetails = {
          coApplicantEmploymentType:
            responseData.data.recommendation.coApplicantEmploymentType !== null
              ? JSON.stringify(responseData.data.recommendation.coApplicantEmploymentType)
              : ' ',
          coApplicantEmploymentTypeId: responseData.data.recommendation.coApplicantEmploymentTypeId,
          coApplicantEmploymentTypeArray:
            recommendationState.coApplicantDetails.coApplicantEmploymentTypeArray,

          coApplicantEmploymentSubType:
            responseData.data.recommendation.coApplicantEmploymentSubType !== null
              ? JSON.stringify(responseData.data.recommendation.coApplicantEmploymentSubType)
              : ' ',
          coApplicantEmploymentSubTypeId:
            responseData.data.recommendation.coApplicantEmploymentSubTypeId,
          coApplicantEmploymentSubTypeArray:
            recommendationState.coApplicantDetails.coApplicantEmploymentSubTypeArray,
          yearlyTurnover: responseData.data.recommendation.coApplicantYearlyTurnover,
          yearlyNetProfit: responseData.data.recommendation.coApplicantYearlyNetProfit,
          yearlyDepreciation: responseData.data.recommendation.coApplicantYearlyDepreciation,
          yearlyInterest: responseData.data.recommendation.coApplicantYearlyInterest,
          typeOfSalary:
            responseData.data.recommendation.coApplicantSalaryType !== null
              ? JSON.stringify(responseData.data.recommendation.coApplicantSalaryType)
              : ' ',
          typeOfSalaryId: responseData.data.recommendation.coApplicantSalaryTypeId,

          typeOfSalaryArray: recommendationState.coApplicantDetails.typeOfSalaryArray,
          grossSalaryPerAnnum: responseData.data.recommendation.coApplicantGrossSalaryPerAnnum,
          monthlySalaryNetTakeHome:
            responseData.data.recommendation.coApplicantMonthlySalaryNetTakeHome,
          monthlyIncentiveBonusIncome:
            responseData.data.recommendation.coApplicantMonthlyIncentiveBonusIncome,
          monthlyCashIncome: responseData.data.recommendation.coApplicantMonthlyCashIncome,
          monthlyRentalIncome: responseData.data.recommendation.coApplicantMonthlyRentalIncome,
          monthlyInterestIncome: responseData.data.recommendation.coApplicantMonthlyInterestIncome,
          otherIncomeMonthly: responseData.data.recommendation.coApplicantOtherIncomeMonthly,
          totalNoOfLoans: responseData.data.recommendation.coApplicantTotalNoOfLoans,
          totalMonthlyInstallments:
            responseData.data.recommendation.coApplicantTotalMonthlyInstalments,
          coApplicantCompanyCreditScore:
            responseData.data.recommendation.coApplicantCompanyCreditScore,
          coApplicantCreditScore: responseData.data.recommendation.coApplicantCreditScore,
          coapplicantJobContinuity: responseData.data.recommendation.coapplicantJobContinuity,
          coApplicantDateOfBirth: responseData.data.recommendation.coApplicantDateOfBirth
        };

        setTimeout(() => {
          console.log('prevDataprevData', prevData);
          setRecommendationState(prevData);
          recommendationApiFire(
            'employmentSubType',
            responseData.data.recommendation.employmentTypeId
          );
          recommendationApiFire('loanSubType', responseData.data.recommendation.loanTypeId);
          recommendationApiFire('cityList', responseData.data.recommendation.stateId);
        }, 100);
      }
    } else if (responseData.status === 'error') {
      setOpenLoader(false);
      // setErrorHandling({ open: true, message: responseData.msg });
      setErrorHandling({ open: true, message: 'Something went wrong' });
    }
  };

  const formValidation = (type) => {
    if (type === 'loanDetails') {
      const prevPopCommonStateData = popCommonState;
      console.log('recommendationState', recommendationState);
      if (
        recommendationState.loanDetails.name === null ||
        recommendationState.loanDetails.name === ''
      ) {
        prevPopCommonStateData.errorMessage = 'Enter Your Name';
        prevPopCommonStateData.errorPopUp = true;
      } else if (
        recommendationState.loanDetails.mobile === '' ||
        recommendationState.loanDetails.mobile === null
      ) {
        prevPopCommonStateData.errorMessage = 'Enter Mobile No';
        prevPopCommonStateData.errorPopUp = true;
      } else if (
        recommendationState.loanDetails.email === '' ||
        recommendationState.loanDetails.email === null
      ) {
        prevPopCommonStateData.errorMessage = 'Enter Your Email Id';
        prevPopCommonStateData.errorPopUp = true;
      } else if (
        recommendationState.loanDetails.employmentType === ' ' ||
        recommendationState.loanDetails.employmentType === null
      ) {
        prevPopCommonStateData.errorMessage = 'Select Employment Type';
        prevPopCommonStateData.errorPopUp = true;
      } else if (
        recommendationState.loanDetails.employmentSubType === ' ' ||
        recommendationState.loanDetails.employmentSubType === null
      ) {
        prevPopCommonStateData.errorMessage = 'Select Employment Sub Type';
        prevPopCommonStateData.errorPopUp = true;
      } else if (
        recommendationState.loanDetails.loanType === ' ' ||
        recommendationState.loanDetails.loanType === null
      ) {
        prevPopCommonStateData.errorMessage = 'Select Loan Type';
        prevPopCommonStateData.errorPopUp = true;
      } else if (
        recommendationState.loanDetails.loanSubType === ' ' ||
        recommendationState.loanDetails.loanSubType === null
      ) {
        prevPopCommonStateData.errorMessage = 'Select Loan Sub Type';
        prevPopCommonStateData.errorPopUp = true;
      } else if (
        recommendationState.loanDetails.loan_amount === '' ||
        recommendationState.loanDetails.loan_amount === null
      ) {
        prevPopCommonStateData.errorMessage = 'Enter Loan Amount';
        prevPopCommonStateData.errorPopUp = true;
      } else if (
        recommendationState.loanDetails.loan_tenure === '' ||
        recommendationState.loanDetails.loan_tenure === null
      ) {
        prevPopCommonStateData.errorMessage = 'Enter Loan Tenure';
        prevPopCommonStateData.errorPopUp = true;
      }
      setPopCommonState(prevPopCommonStateData);
      setMutateState(new Date());
      if (prevPopCommonStateData.errorPopUp !== true) {
        recommendationApiFire('saveRecommendation', null);
      }
    } else if (type === 'customerDetails') {
      const prevPopCommonStateData = popCommonState;
      const viewRecommendation = JSON.parse(localStorage.getItem(`viewRecommendation`));
      if (
        recommendationState.customerDetails.dateOfBirth === null ||
        recommendationState.customerDetails.dateOfBirth === ''
      ) {
        prevPopCommonStateData.errorMessage = 'Enter customer date of birth';
        prevPopCommonStateData.errorPopUp = true;
      } else if (
        recommendationState.customerDetails.totalJobContinuityInMonths === null ||
        recommendationState.customerDetails.totalJobContinuityInMonths === ''
      ) {
        prevPopCommonStateData.errorMessage = 'Enter total job continuity in months';
        prevPopCommonStateData.errorPopUp = true;
      } else if (
        recommendationState.customerDetails.customerCreditScore === null ||
        recommendationState.customerDetails.customerCreditScore === ''
      ) {
        prevPopCommonStateData.errorMessage = 'Enter customer credit score';
        prevPopCommonStateData.errorPopUp = true;
      } else if (
        recommendationState.customerDetails.propertyAge === null ||
        recommendationState.customerDetails.propertyAge === ''
      ) {
        prevPopCommonStateData.errorMessage = 'Enter property age';
        prevPopCommonStateData.errorPopUp = true;
      }

      setPopCommonState(prevPopCommonStateData);
      setMutateState(new Date());
      if (viewRecommendation !== null && prevPopCommonStateData.errorPopUp !== true) {
        recommendationApiFire('saveRecommendation', viewRecommendation.recommendationId);
      }
    } else {
      const prevPopCommonStateData = popCommonState;
      const viewRecommendation = JSON.parse(localStorage.getItem(`viewRecommendation`));
      if (
        recommendationState.coApplicantDetails.coApplicantDateOfBirth === null ||
        recommendationState.coApplicantDetails.coApplicantDateOfBirth === ''
      ) {
        prevPopCommonStateData.errorMessage = 'Enter Co Applicant date of birth';
        prevPopCommonStateData.errorPopUp = true;
      }
      setPopCommonState(prevPopCommonStateData);
      setMutateState(new Date());
      if (viewRecommendation !== null && prevPopCommonStateData.errorPopUp !== true) {
        recommendationApiFire('saveRecommendation', viewRecommendation.recommendationId);
      }
    }
  };

  const closePopUp = () => {
    setPopCommonState({ errorMessage: '', errorPopUp: false });
  };

  return (
    <Page title="Klass Management System || Leads">
      <Container maxWidth="">
        <Box pt={3} pb={3} mb={4}>
          <Stack
            direction="row"
            alignItems="center"
            justifyContent="space-between"
            className="pageHeading"
          >
            <PageTitle info="Recommendation" />
            <Box>
              <BrudCrumbs />
            </Box>
          </Stack>
          <Stepper
            connector=""
            activeStep={activeStep}
            sx={{ marginBottom: '1.25rem' }}
            className="stepWizardOuter"
          >
            <Step className="stepWizard">
              <StepLabel
                className="stepWizardLabel"
                LabelProps={{
                  className: 'stepLabel'
                }}
              >
                Loan Details
              </StepLabel>
            </Step>

            <Step className="stepWizard">
              <StepLabel className="stepWizardLabel">Customer Details</StepLabel>
            </Step>

            <Step className="stepWizard">
              <StepLabel className="stepWizardLabel">Co Applicant Details</StepLabel>
            </Step>

            <Step className="stepWizard">
              <StepLabel className="stepWizardLabel">Result</StepLabel>
            </Step>
          </Stepper>
          {activeStep === 0 ? (
            <Step1Content
              recommendationState={recommendationState}
              setRecommendationState={setRecommendationState}
              formValidation={formValidation}
              recommendationApiFire={recommendationApiFire}
            />
          ) : activeStep === 1 ? (
            <Step2Content
              handleNextBackFinish={handleNextBackFinish}
              recommendationState={recommendationState}
              setRecommendationState={setRecommendationState}
              formValidation={formValidation}
              recommendationApiFire={recommendationApiFire}
            />
          ) : activeStep === 2 ? (
            <Step3Content
              handleNextBackFinish={handleNextBackFinish}
              recommendationState={recommendationState}
              setRecommendationState={setRecommendationState}
              formValidation={formValidation}
              recommendationApiFire={recommendationApiFire}
            />
          ) : (
            <Step4Content
              handleNextBackFinish={handleNextBackFinish}
              getrecomdationDataList={getrecomdationDataList}
            />
          )}
        </Box>

        <Dialog
          open={popCommonState.errorPopUp}
          onClose={closePopUp}
          aria-labelledby="alert-dialog-title"
          aria-describedby="alert-dialog-description"
        >
          <DialogContent>
            <DialogContentText id="alert-dialog-description">
              {popCommonState.errorMessage}
            </DialogContentText>
          </DialogContent>
          <DialogActions>
            <Button onClick={closePopUp}>Retry</Button>
          </DialogActions>
        </Dialog>
        <Dialog
          open={errorHandling.open}
          onClose={(e) => setErrorHandling({ open: false, message: null })}
          fullWidth
        >
          <DialogContent dividers>
            <Box className="" py={2}>
              {errorHandling.message}
            </Box>
          </DialogContent>
          <DialogActions>
            <Button
              onClick={(e) => {
                setErrorHandling({ open: false, message: null });
              }}
              variant="contained"
              className="mainBtn"
            >
              Close
            </Button>
          </DialogActions>
        </Dialog>
        <Loader openLoader={openLoader} />
      </Container>
    </Page>
  );
}

function Step1Content({
  recommendationState,
  setRecommendationState,
  formValidation,
  recommendationApiFire
}) {
  const [selectEmploymentSubType, setSelectEmploymentSubType] = useState(' ');
  const [selectLoanType, setSelectLoanType] = useState(' ');
  const [selectLoanSubType, setSelectLoanSubType] = useState(' ');
  const [selectLoginType, setSelectLoginType] = useState(' ');
  const [selectDate, setSelectDate] = useState(' ');
  const [isActive, setIsActive] = useState(false);
  const [isActiveA, setIsActiveA] = useState(false);
  const [open, setOpen] = useState(false);

  const handleClickOpen = () => {
    setOpen(true);
  };
  const handleClose = () => {
    setOpen(false);
    setIsActive((current) => !current);
  };
  const [open1, setOpen1] = useState(false);
  const handleClickOpenA = () => {
    setOpen1(true);
  };
  const handleCloseA = () => {
    setOpen1(false);
    setIsActiveA((current) => !current);
  };
  return (
    <>
      <Typography variant="body1" className="headingLineUp headingLineUpOut">
        Personal Detail
      </Typography>
      <Box className="viewLeadCard cardTopMinusMargin" mb={3}>
        <Grid container spacing={{ xs: 1, sm: 2, md: 3 }}>
          <Grid item xs={12} sm={6} md={4}>
            <FormControl required fullWidth className="formGroup">
              <Typography variant="body1" className="formLabel">
                Name
              </Typography>
              <TextField
                inputProps={{ className: 'textInput' }}
                fullWidth
                placeholder="Type Name"
                value={recommendationState.loanDetails.name}
                onChange={(e) => {
                  const prevData = recommendationState.loanDetails;
                  prevData.name = e.target.value;
                  setRecommendationState({ ...recommendationState, loanDetails: prevData });
                }}
              />
            </FormControl>
          </Grid>
          <Grid item xs={12} sm={6} md={4}>
            <FormControl required fullWidth className="formGroup">
              <Typography variant="body1" className="formLabel">
                Mobile
              </Typography>
              <TextField
                inputProps={{ className: 'textInput' }}
                fullWidth
                placeholder="Type Mobile"
                disabled={isActive}
                value={recommendationState.loanDetails.mobile}
                onChange={(e) => {
                  const prevData = recommendationState.loanDetails;
                  if (/^\d+$/.test(e.target.value.trim())) {
                    prevData.mobile = e.target.value;
                  } else {
                    prevData.mobile = '';
                  }
                  setRecommendationState({ ...recommendationState, loanDetails: prevData });
                }}
              />
              <Button
                className={isActive ? 'verifiedBtn mainBtn' : 'verifyBtn mainBtn'}
                onClick={handleClickOpen}
                disabled="true"
              >
                {isActive ? 'Verified' : 'Verify'}
              </Button>
            </FormControl>
            {/* mobile otp popup start */}
            <Dialog
              className="PopupBox"
              open={open}
              onClose={handleClose}
              aria-labelledby="alert-dialog-title"
              aria-describedby="alert-dialog-description"
            >
              <DialogTitle className="popupTitle">
                <Typography variant="h6">Verify Mobile Number</Typography>
                <IconButton onClick={handleClose} size="small">
                  <CloseIcon />
                </IconButton>
              </DialogTitle>
              <DialogContent dividers className="PopupContent">
                <DialogContentText id="alert-dialog-description">
                  <Typography variant="body2" className="mb-2">
                    (We have send a One Time Password to your Mobile. Please fill in your Mobile OTP
                    to proceed further.)
                  </Typography>
                  <Typography variant="body2" className="FormLabel">
                    Mobile OTP
                  </Typography>
                  <TextField
                    fullWidth
                    inputProps={{
                      className: 'formControl'
                    }}
                    placeholder="Type Mobile OTP"
                  />
                </DialogContentText>
              </DialogContent>
              <DialogActions>
                <Button onClick={handleClose} className="mainBtn">
                  {isActive ? 'Verified' : 'Verify'}
                </Button>
              </DialogActions>
            </Dialog>
            {/* mobile otp popup end */}
          </Grid>
          <Grid item xs={12} sm={6} md={4}>
            <FormControl required fullWidth className="formGroup" style={{ position: 'relative' }}>
              <Typography variant="body1" className="formLabel">
                Email
              </Typography>
              <TextField
                inputProps={{ className: 'textInput' }}
                fullWidth
                placeholder="Type Email"
                disabled={isActiveA}
                value={recommendationState.loanDetails.email}
                onChange={(e) => {
                  const prevData = recommendationState.loanDetails;
                  prevData.email = e.target.value;
                  setRecommendationState({ ...recommendationState, loanDetails: prevData });
                }}
              />
              <Button
                className={isActiveA ? 'verifiedBtn mainBtn' : 'verifyBtn mainBtn'}
                onClick={handleClickOpenA}
                disabled="true"
              >
                {isActiveA ? 'Verified' : 'Verify'}
              </Button>
            </FormControl>
            {/* Email otp popup start */}
            <Dialog
              className="PopupBox"
              open={open1}
              onClose={handleCloseA}
              aria-labelledby="alert-dialog-title"
              aria-describedby="alert-dialog-description"
            >
              <DialogTitle className="popupTitle">
                <Typography variant="h6">Verify Email Number</Typography>
                <IconButton onClick={handleCloseA} size="small">
                  <CloseIcon />
                </IconButton>
              </DialogTitle>
              <DialogContent dividers>
                <DialogContentText id="alert-dialog-description">
                  <Typography variant="body2" className="mb-2">
                    (We have send a One Time Password to your Email. Please fill in your Email OTP
                    to proceed further.)
                  </Typography>
                  <Typography variant="body2" className="FormLabel">
                    Email OTP
                  </Typography>
                  <TextField
                    fullWidth
                    inputProps={{
                      className: 'formControl'
                    }}
                    placeholder="Type Email OTP"
                  />
                </DialogContentText>
              </DialogContent>
              <DialogActions>
                <Button onClick={handleCloseA} className="mainBtn">
                  Verify
                </Button>
              </DialogActions>
            </Dialog>
            {/* Email otp popup end */}
          </Grid>
        </Grid>
      </Box>
      <Typography variant="body1" className="headingLineUp headingLineUpOut">
        Loan Requirement
      </Typography>
      <Box className="viewLeadCard cardTopMinusMargin">
        <Grid container spacing={{ xs: 1, sm: 2, md: 3 }} alignItems="flex-end">
          <Grid item xs={12} sm={6} md={4}>
            <FormControl required fullWidth className="formGroup">
              <Typography variant="body1" className="formLabel">
                Employment Type
              </Typography>
              <Select
                fullWidth
                value={recommendationState.loanDetails.employmentType}
                onChange={(e) => {
                  const prevData = recommendationState.loanDetails;
                  const inputVal = JSON.parse(e.target.value);
                  prevData.employmentSubType = ' ';
                  prevData.employmentType = e.target.value;
                  prevData.employment_type_id = inputVal.employmentCategoryId;
                  setRecommendationState({ ...recommendationState, loanDetails: prevData });
                  recommendationApiFire('employmentSubType', prevData.employment_type_id);
                }}
                inputProps={{
                  className: `textInput customSelectBox dissabledMenu${recommendationState.loanDetails.employmentType}`
                }}
              >
                <MenuItem value=" " disabled>
                  Select Employment Type
                </MenuItem>

                {recommendationState?.loanDetails?.employmentTypeArray?.map(
                  (employmentTypeItem, employmentTypeIndex) => (
                    <MenuItem
                      key={`employmentTypeItem${employmentTypeIndex}`}
                      value={JSON.stringify(employmentTypeItem)}
                    >
                      {employmentTypeItem.employmentCategoryName}
                    </MenuItem>
                  )
                )}
              </Select>
            </FormControl>
          </Grid>
          <Grid item xs={12} sm={6} md={4}>
            <FormControl required fullWidth className="formGroup">
              <Typography variant="body1" className="formLabel">
                Employment Sub Type
              </Typography>
              <Select
                fullWidth
                value={recommendationState.loanDetails.employmentSubType}
                onChange={(e) => {
                  const prevData = recommendationState.loanDetails;
                  const inputVal = JSON.parse(e.target.value);
                  prevData.employmentSubType = e.target.value;
                  prevData.employment_sub_type_id = inputVal.employmentSubcategoryId;
                  setRecommendationState({ ...recommendationState, loanDetails: prevData });
                }}
                inputProps={{
                  className: `textInput customSelectBox dissabledMenu${recommendationState.loanDetails.employmentSubType}`
                }}
              >
                <MenuItem value=" " disabled>
                  Select Employment Sub Type
                </MenuItem>
                {recommendationState?.loanDetails?.employmentSubTypeArray?.map(
                  (employmentSubTypeItem, employmentSubTypeIndex) => (
                    <MenuItem
                      key={`employmentSubTypeItem${employmentSubTypeIndex}`}
                      value={JSON.stringify(employmentSubTypeItem)}
                    >
                      {employmentSubTypeItem.employmentSubcategoryName}
                    </MenuItem>
                  )
                )}
              </Select>
            </FormControl>
          </Grid>
          <Grid item xs={12} sm={6} md={4}>
            <FormControl required fullWidth className="formGroup">
              <Typography variant="body1" className="formLabel">
                Loan Type
              </Typography>
              <Select
                onChange={(e) => {
                  const prevData = recommendationState.loanDetails;
                  prevData.loanSubType = ' ';
                  const inputVal = JSON.parse(e.target.value);
                  prevData.loanType = e.target.value;
                  prevData.loan_type_id = inputVal.parentLoanId;
                  setRecommendationState({ ...recommendationState, loanDetails: prevData });
                  recommendationApiFire('loanSubType', prevData.loan_type_id);
                }}
                value={recommendationState.loanDetails.loanType}
                displayEmpty
                inputProps={{
                  className: `textInput customSelectBox dissabledMenu${recommendationState.loanDetails.loanType}`
                }}
              >
                <MenuItem value=" " disabled>
                  Select Loan Type
                </MenuItem>
                {recommendationState?.loanDetails?.loanTypeArray?.map((loanItem, loanIndex) => (
                  <MenuItem key={`loanItem${loanIndex}`} value={JSON.stringify(loanItem)}>
                    {loanItem.parentLoanName}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>
          </Grid>
          <Grid item xs={12} sm={6} md={4}>
            <FormControl required fullWidth className="formGroup">
              <Typography variant="body1" className="formLabel">
                Loan Sub Type
              </Typography>
              <Select
                onChange={(e) => {
                  const prevData = recommendationState.loanDetails;
                  const inputVal = JSON.parse(e.target.value);
                  prevData.loanSubType = e.target.value;
                  prevData.loan_sub_type_id = inputVal.loanId;
                  setRecommendationState({ ...recommendationState, loanDetails: prevData });
                }}
                value={recommendationState.loanDetails.loanSubType}
                displayEmpty
                inputProps={{
                  className: `textInput customSelectBox dissabledMenu${recommendationState.loanDetails.loanSubType}`
                }}
              >
                <MenuItem value=" " disabled>
                  Select Loan Sub Type
                </MenuItem>
                {recommendationState?.loanDetails?.loanSubTypeArray?.map(
                  (loanSubItem, loanSubIndex) => (
                    <MenuItem
                      key={`loanSubItem${loanSubIndex}`}
                      value={JSON.stringify(loanSubItem)}
                    >
                      {loanSubItem.loanName}
                    </MenuItem>
                  )
                )}
              </Select>
            </FormControl>
          </Grid>
          <Grid item xs={12} sm={6} md={4}>
            <FormControl required fullWidth className="formGroup">
              <Typography variant="body1" className="formLabel">
                Loan Amount
              </Typography>
              <TextField
                fullWidth
                inputProps={{ className: 'textInput' }}
                placeholder="Type Loan Amount"
                value={recommendationState.loanDetails.loan_amount}
                onChange={(e) => {
                  const prevData = recommendationState.loanDetails;
                  if (/^\d+$/.test(e.target.value.trim())) {
                    prevData.loan_amount = e.target.value;
                  } else {
                    prevData.loan_amount = '';
                  }
                  setRecommendationState({ ...recommendationState, loanDetails: prevData });
                }}
              />
            </FormControl>
          </Grid>
          <Grid item xs={12} sm={6} md={4}>
            <FormControl required fullWidth className="formGroup">
              <Typography variant="body1" className="formLabel">
                Loan Tenure
              </Typography>
              <TextField
                fullWidth
                inputProps={{ className: 'textInput' }}
                placeholder="Type Loan Tenure"
                value={recommendationState.loanDetails.loan_tenure}
                onChange={(e) => {
                  const prevData = recommendationState.loanDetails;
                  if (/^\d+$/.test(e.target.value.trim())) {
                    prevData.loan_tenure = e.target.value;
                  } else {
                    prevData.loan_tenure = '';
                  }
                  setRecommendationState({ ...recommendationState, loanDetails: prevData });
                }}
              />
            </FormControl>
          </Grid>
          {/* <Grid item xs>
            <Button className="mainBtn mainBtnSec mainBtnSmall">Go</Button>
          </Grid> */}
        </Grid>
      </Box>
      <Box sx={{ display: 'flex', paddingTop: '1.5rem' }}>
        <Button
          onClick={() => formValidation('loanDetails')}
          className="mainBtn nextBtn"
          endIcon={<HiOutlineArrowNarrowRight />}
          variant="contained"
        >
          Next
        </Button>
      </Box>
    </>
  );
}

function Step2Content({
  handleNextBackFinish,
  recommendationState,
  setRecommendationState,
  formValidation,
  recommendationApiFire
}) {
  const [selectGender, setSelectGender] = useState(' ');
  const [selectMaritalStatus, setSelectMaritalStatus] = useState(' ');
  const [selectOrganizationType, setSelectOrganizationType] = useState(' ');
  const [selectSalaryType, setSelectSalaryType] = useState(' ');
  const [selectCoApplicantEmpStatus, setSelectCoApplicantEmpStatus] = useState(' ');
  const [selectCoApplicantEmpType, setSelectCoApplicantEmpType] = useState(' ');
  const [selectPropertyType, setSelectPropertyType] = useState(' ');
  const [selectOwnershipType, setSelectOwnershipType] = useState(' ');
  const [selectStageConstruction, setSelectStageConstruction] = useState(' ');
  const [selectLocationType, setSelectLocationType] = useState(' ');
  const [selectPurchaseType, setSelectPurchaseType] = useState(' ');
  const [selectProjectStatus, setSelectProjectStatus] = useState(' ');
  const [selectOrgnization, setSelectOrgnization] = useState(' ');
  const [selectBusinessProofRequired, setSelectBusinessProofRequired] = useState(' ');
  const [selectProfession, setSelectProfession] = useState(' ');
  const [deleteConfirm, setDeleteConfirm] = useState(false);
  const [fullWidth, setFullWidth] = useState(true);
  const [maxWidth, setMaxWidth] = useState('md');
  console.log('recommendationState', recommendationState);
  return (
    <>
      <Typography variant="body1" className="headingLineUp headingLineUpOut">
        Applicant Details
      </Typography>
      <Box className="viewLeadCard cardTopMinusMargin" mb={3}>
        <Grid container spacing={{ xs: 1, sm: 2, md: 3 }}>
          {JSON.parse(recommendationState?.loanDetails?.employmentType).employmentCategoryName ===
            'Salaried' ||
          JSON.parse(recommendationState?.loanDetails?.employmentType).employmentCategoryName ===
            'Business' ? (
            <Grid item xs={4}>
              <FormControl required fullWidth className="formGroup">
                <Typography variant="body1" className="formLabel">
                  Date of Birth
                </Typography>
                <TextField
                  value={recommendationState.customerDetails.dateOfBirth}
                  onChange={(e) => {
                    const prevData = recommendationState.customerDetails;
                    prevData.dateOfBirth = e.target.value;
                    setRecommendationState({ ...recommendationState, customerDetails: prevData });
                  }}
                  type="date"
                  inputProps={{ className: 'textInput' }}
                  fullWidth
                  placeholder="Select Date"
                />
              </FormControl>
            </Grid>
          ) : (
            <>
              <Grid item xs={4}>
                <FormControl required fullWidth className="formGroup">
                  <Typography variant="body1" className="formLabel">
                    Company Name
                  </Typography>
                  <TextField
                    inputProps={{ className: 'textInput' }}
                    fullWidth
                    placeholder="Type Company Name"
                    value={recommendationState.customerDetails.companyName}
                    onChange={(e) => {
                      const prevData = recommendationState.customerDetails;
                      prevData.companyName = e.target.value;
                      setRecommendationState({ ...recommendationState, customerDetails: prevData });
                    }}
                  />
                </FormControl>
              </Grid>
              <Grid item xs={4}>
                <FormControl required fullWidth className="formGroup">
                  <Typography variant="body1" className="formLabel">
                    Type of Organization
                  </Typography>
                  <Select
                    onChange={(e) => {
                      const prevData = recommendationState.customerDetails;
                      const inputVal = JSON.parse(e.target.value);
                      prevData.typeOfOrganizationId = inputVal.typeId;
                      prevData.typeOfOrganization = e.target.value;
                      setRecommendationState({ ...recommendationState, customerDetails: prevData });
                    }}
                    value={recommendationState.customerDetails.typeOfOrganization}
                    displayEmpty
                    inputProps={{
                      className: `textInput customSelectBox dissabledMenu${recommendationState.customerDetails.typeOfOrganization}`
                    }}
                  >
                    <MenuItem value=" " disabled>
                      Select Type of Organization
                    </MenuItem>
                    {recommendationState.customerDetails.typeOfOrganizationArray.map(
                      (typeOfOrganizationArrayItem, typeOfOrganizationArrayIndex) => (
                        <MenuItem
                          key={`typeOfOrganizationArrayItem${typeOfOrganizationArrayIndex}`}
                          value={JSON.stringify(typeOfOrganizationArrayItem)}
                        >
                          {typeOfOrganizationArrayItem.typeName}
                        </MenuItem>
                      )
                    )}
                  </Select>
                </FormControl>
              </Grid>
            </>
          )}
          <Grid item xs={4}>
            <FormControl required fullWidth className="formGroup">
              <Typography variant="body1" className="formLabel">
                PAN Number
              </Typography>
              <TextField
                value={recommendationState.customerDetails.pan_number}
                onChange={(e) => {
                  const prevData = recommendationState.customerDetails;
                  prevData.pan_number = e.target.value;
                  setRecommendationState({ ...recommendationState, customerDetails: prevData });
                }}
                inputProps={{ className: 'textInput' }}
                fullWidth
                placeholder="Type PAN Number"
              />
            </FormControl>
          </Grid>
          {JSON.parse(recommendationState?.loanDetails?.employmentType).employmentCategoryName ===
          'Salaried' ? (
            <>
              <Grid item xs={4}>
                <FormControl required fullWidth className="formGroup">
                  <Typography variant="body1" className="formLabel">
                    Aadhar Number
                  </Typography>
                  <TextField
                    value={recommendationState.customerDetails.aadharNumber}
                    onChange={(e) => {
                      const prevData = recommendationState.customerDetails;
                      prevData.aadharNumber = e.target.value;
                      setRecommendationState({ ...recommendationState, customerDetails: prevData });
                    }}
                    inputProps={{ className: 'textInput' }}
                    fullWidth
                    placeholder="Type Aadhar Number"
                  />
                </FormControl>
              </Grid>
              <Grid item xs={4}>
                <FormControl required fullWidth className="formGroup">
                  <Typography variant="body1" className="formLabel">
                    Gender
                  </Typography>
                  <Select
                    value={recommendationState.customerDetails.gender}
                    onChange={(e) => {
                      const prevData = recommendationState.customerDetails;
                      const inputVal = JSON.parse(e.target.value);
                      prevData.gender_type_id = inputVal.typeId;
                      prevData.gender = e.target.value;
                      setRecommendationState({ ...recommendationState, customerDetails: prevData });
                    }}
                    displayEmpty
                    inputProps={{
                      className: `textInput customSelectBox dissabledMenu${selectGender}`
                    }}
                  >
                    <MenuItem value=" " disabled>
                      Select Gender
                    </MenuItem>
                    {recommendationState?.customerDetails?.genderArray?.map(
                      (genderItem, genderItemIndex) => (
                        <MenuItem
                          key={`genderItem${genderItemIndex}`}
                          value={JSON.stringify(genderItem)}
                        >
                          {genderItem.typeName}
                        </MenuItem>
                      )
                    )}
                  </Select>
                </FormControl>
              </Grid>
              <Grid item xs={4}>
                <FormControl required fullWidth className="formGroup">
                  <Typography variant="body1" className="formLabel">
                    Marital Status
                  </Typography>
                  <Select
                    value={recommendationState.customerDetails.maritalStatus}
                    onChange={(e) => {
                      const prevData = recommendationState.customerDetails;
                      const inputVal = JSON.parse(e.target.value);
                      prevData.maritalstatus_type_id = inputVal.typeId;
                      prevData.maritalStatus = e.target.value;
                      setRecommendationState({ ...recommendationState, customerDetails: prevData });
                    }}
                    displayEmpty
                    inputProps={{
                      className: `textInput customSelectBox dissabledMenu${selectMaritalStatus}`
                    }}
                  >
                    <MenuItem value=" " disabled>
                      Select Marital Status
                    </MenuItem>
                    {recommendationState?.customerDetails?.maritalStatusArray?.map(
                      (itemNo, itemNoIndex) => (
                        <MenuItem key={`itemNo${itemNoIndex}`} value={JSON.stringify(itemNo)}>
                          {itemNo.typeName}
                        </MenuItem>
                      )
                    )}
                  </Select>
                </FormControl>
              </Grid>
              <Grid item xs={4}>
                <FormControl required fullWidth className="formGroup">
                  <Typography variant="body1" className="formLabel">
                    Location
                  </Typography>
                  <TextField
                    value={recommendationState.customerDetails.location}
                    onChange={(e) => {
                      const prevData = recommendationState.customerDetails;
                      prevData.location = e.target.value;
                      setRecommendationState({ ...recommendationState, customerDetails: prevData });
                    }}
                    type="number"
                    inputProps={{ className: 'textInput' }}
                    fullWidth
                    placeholder="Type Pincode"
                  />
                </FormControl>
              </Grid>
            </>
          ) : (
            <>
              <Grid item xs={4}>
                <FormControl required fullWidth className="formGroup">
                  <Typography variant="body1" className="formLabel">
                    GST Number
                  </Typography>
                  <TextField
                    inputProps={{ className: 'textInput' }}
                    fullWidth
                    placeholder="Type GST Number"
                    value={recommendationState.customerDetails.gst_number}
                    onChange={(e) => {
                      const prevData = recommendationState.customerDetails;
                      prevData.gst_number = e.target.value;
                      setRecommendationState({ ...recommendationState, customerDetails: prevData });
                    }}
                  />
                </FormControl>
              </Grid>
              <Grid item xs={4}>
                <FormControl required fullWidth className="formGroup">
                  <Typography variant="body1" className="formLabel">
                    Data of Incorporation
                  </Typography>
                  <TextField
                    type="date"
                    inputProps={{ className: 'textInput' }}
                    fullWidth
                    placeholder="Select Date"
                    value={recommendationState.customerDetails.dataOfIncorporation}
                    onChange={(e) => {
                      const prevData = recommendationState.customerDetails;
                      prevData.dataOfIncorporation = e.target.value;
                      setRecommendationState({ ...recommendationState, customerDetails: prevData });
                    }}
                  />
                </FormControl>
              </Grid>
              <Grid item xs={4}>
                <FormControl required fullWidth className="formGroup">
                  <Typography variant="body1" className="formLabel">
                    Office Location (Pincode)
                  </Typography>
                  <TextField
                    inputProps={{ className: 'textInput' }}
                    fullWidth
                    placeholder="Type PinCode"
                    value={recommendationState.customerDetails.officeLocationPincode}
                    onChange={(e) => {
                      const prevData = recommendationState.customerDetails;
                      if (/^\d+$/.test(e.target.value.trim())) {
                        prevData.officeLocationPincode = e.target.value;
                      } else {
                        prevData.officeLocationPincode = '';
                      }
                      setRecommendationState({ ...recommendationState, customerDetails: prevData });
                    }}
                  />
                </FormControl>
              </Grid>
              <Grid item xs={4}>
                <FormControl required fullWidth className="formGroup">
                  <Typography variant="body1" className="formLabel">
                    Business Proof Required
                  </Typography>
                  <Select
                    onChange={(e) => {
                      const prevData = recommendationState.customerDetails;
                      prevData.businessProofRequired = e.target.value;
                      if (prevData.businessProofRequired === 'Yes') {
                        prevData.businessProofRequired = true;
                      } else {
                        prevData.businessProofRequired = false;
                      }
                      setRecommendationState({ ...recommendationState, customerDetails: prevData });
                    }}
                    value={
                      recommendationState.customerDetails.businessProofRequired === true
                        ? 'Yes'
                        : 'No'
                    }
                    displayEmpty
                    inputProps={{
                      className: `textInput customSelectBox dissabledMenu${recommendationState.customerDetails.businessProofRequired}`
                    }}
                  >
                    <MenuItem value=" " disabled>
                      Select Business Proof Required
                    </MenuItem>
                    <MenuItem value="Yes">Yes</MenuItem>
                    <MenuItem value="No">No</MenuItem>
                  </Select>
                </FormControl>
              </Grid>
            </>
          )}
        </Grid>
      </Box>
      {JSON.parse(recommendationState?.loanDetails?.employmentType).employmentCategoryName ===
        'Salaried' ||
      JSON.parse(recommendationState?.loanDetails?.employmentType).employmentCategoryName ===
        'Business' ? (
        <>
          <Typography variant="body1" className="headingLineUp headingLineUpOut">
            Applicant Employment
          </Typography>
          <Box className="viewLeadCard cardTopMinusMargin" mb={3}>
            <Grid container spacing={{ xs: 1, sm: 2, md: 3 }}>
              <Grid item xs={4}>
                <FormControl required fullWidth className="formGroup">
                  <Typography variant="body1" className="formLabel">
                    Company Name
                  </Typography>
                  <TextField
                    inputProps={{ className: 'textInput' }}
                    fullWidth
                    placeholder="Type Company Name"
                    value={recommendationState.customerDetails.companyName}
                    onChange={(e) => {
                      const prevData = recommendationState.customerDetails;
                      prevData.companyName = e.target.value;
                      setRecommendationState({ ...recommendationState, customerDetails: prevData });
                    }}
                  />
                </FormControl>
              </Grid>
              <Grid item xs={4}>
                <FormControl required fullWidth className="formGroup">
                  <Typography variant="body1" className="formLabel">
                    Type of Organization
                  </Typography>
                  <Select
                    onChange={(e) => {
                      const prevData = recommendationState.customerDetails;
                      const inputVal = JSON.parse(e.target.value);
                      prevData.typeOfOrganizationId = inputVal.typeId;
                      prevData.typeOfOrganization = e.target.value;
                      setRecommendationState({ ...recommendationState, customerDetails: prevData });
                    }}
                    value={recommendationState.customerDetails.typeOfOrganization}
                    displayEmpty
                    inputProps={{
                      className: `textInput customSelectBox dissabledMenu${recommendationState.customerDetails.typeOfOrganization}`
                    }}
                  >
                    <MenuItem value=" " disabled>
                      Select Type of Organization
                    </MenuItem>
                    {recommendationState.customerDetails.typeOfOrganizationArray.map(
                      (typeOfOrganizationArrayItem, typeOfOrganizationArrayIndex) => (
                        <MenuItem
                          key={`typeOfOrganizationArrayItem${typeOfOrganizationArrayIndex}`}
                          value={JSON.stringify(typeOfOrganizationArrayItem)}
                        >
                          {typeOfOrganizationArrayItem.typeName}
                        </MenuItem>
                      )
                    )}
                  </Select>
                </FormControl>
              </Grid>
              <Grid item xs={4}>
                <FormControl required fullWidth className="formGroup">
                  <Typography variant="body1" className="formLabel">
                    Total Work Experience
                  </Typography>
                  <TextField
                    onChange={(e) => {
                      const prevData = recommendationState.customerDetails;
                      if (/^\d+$/.test(e.target.value.trim())) {
                        prevData.totalworkexperienceinmonths = e.target.value;
                      } else {
                        prevData.totalworkexperienceinmonths = '';
                      }
                      setRecommendationState({ ...recommendationState, customerDetails: prevData });
                    }}
                    value={recommendationState.customerDetails.totalworkexperienceinmonths}
                    inputProps={{ className: 'textInput' }}
                    fullWidth
                    placeholder="Type Total Work Experience"
                  />
                </FormControl>
              </Grid>
              <Grid item xs={4}>
                <FormControl required fullWidth className="formGroup">
                  <Typography variant="body1" className="formLabel">
                    No of Months in Current Job
                  </Typography>
                  <TextField
                    onChange={(e) => {
                      const prevData = recommendationState.customerDetails;
                      if (/^\d+$/.test(e.target.value.trim())) {
                        prevData.noOfMonthsInCurrentJob = e.target.value;
                      } else {
                        prevData.noOfMonthsInCurrentJob = '';
                      }
                      setRecommendationState({ ...recommendationState, customerDetails: prevData });
                    }}
                    value={recommendationState.customerDetails.noOfMonthsInCurrentJob}
                    inputProps={{ className: 'textInput' }}
                    fullWidth
                    placeholder="Type No of Months in Current Job"
                  />
                </FormControl>
              </Grid>
              <Grid item xs={4}>
                <FormControl required fullWidth className="formGroup">
                  <Typography variant="body1" className="formLabel">
                    Total Job Continuity in Months
                  </Typography>
                  <TextField
                    onChange={(e) => {
                      const prevData = recommendationState.customerDetails;
                      if (/^\d+$/.test(e.target.value.trim())) {
                        prevData.totalJobContinuityInMonths = e.target.value;
                      } else {
                        prevData.totalJobContinuityInMonths = '';
                      }
                      setRecommendationState({ ...recommendationState, customerDetails: prevData });
                    }}
                    value={recommendationState.customerDetails.totalJobContinuityInMonths}
                    inputProps={{ className: 'textInput' }}
                    fullWidth
                    placeholder="Type Total Job Continuity in Months"
                  />
                </FormControl>
              </Grid>
            </Grid>
          </Box>
        </>
      ) : (
        ''
      )}

      <Typography variant="body1" className="headingLineUp headingLineUpOut">
        Applicant Income
      </Typography>
      <Box className="viewLeadCard cardTopMinusMargin" mb={3}>
        <Grid container spacing={{ xs: 1, sm: 2, md: 3 }}>
          {JSON.parse(recommendationState?.loanDetails?.employmentType).employmentCategoryName ===
          'Salaried' ? (
            <>
              <Grid item xs={4}>
                <FormControl required fullWidth className="formGroup">
                  <Typography variant="body1" className="formLabel">
                    Type of Salary
                  </Typography>
                  <Select
                    value={recommendationState.customerDetails.typeOfSalary}
                    onChange={(e) => {
                      const prevData = recommendationState.customerDetails;
                      const inputVal = JSON.parse(e.target.value);
                      prevData.typeOfSalaryId = inputVal.typeId;
                      prevData.typeOfSalary = e.target.value;
                      setRecommendationState({ ...recommendationState, customerDetails: prevData });
                    }}
                    displayEmpty
                    inputProps={{
                      className: `textInput customSelectBox dissabledMenu${selectSalaryType}`
                    }}
                  >
                    <MenuItem value=" " disabled>
                      Select Type of Salary
                    </MenuItem>
                    {recommendationState?.customerDetails?.typeOfSalaryArray?.map(
                      (itemNo, itemNoIndex) => (
                        <MenuItem key={`itemNo${itemNoIndex}`} value={JSON.stringify(itemNo)}>
                          {itemNo.typeName}
                        </MenuItem>
                      )
                    )}
                  </Select>
                </FormControl>
              </Grid>
              <Grid item xs={4}>
                <FormControl required fullWidth className="formGroup">
                  <Typography variant="body1" className="formLabel">
                    Gross Salary Per Annum
                  </Typography>
                  <TextField
                    value={recommendationState.customerDetails.grossSalaryPerAnnum}
                    onChange={(e) => {
                      const prevData = recommendationState.customerDetails;
                      if (/^\d+$/.test(e.target.value.trim())) {
                        prevData.grossSalaryPerAnnum = e.target.value;
                      } else {
                        prevData.grossSalaryPerAnnum = '';
                      }
                      setRecommendationState({ ...recommendationState, customerDetails: prevData });
                    }}
                    inputProps={{ className: 'textInput' }}
                    fullWidth
                    placeholder="Type Gross Salary Per Annum"
                  />
                </FormControl>
              </Grid>
              <Grid item xs={4}>
                <FormControl required fullWidth className="formGroup">
                  <Typography variant="body1" className="formLabel">
                    Monthly Salary (Net Take Home)
                  </Typography>
                  <TextField
                    value={recommendationState.customerDetails.monthlySalaryNetTakeHome}
                    onChange={(e) => {
                      const prevData = recommendationState.customerDetails;
                      if (/^\d+$/.test(e.target.value.trim())) {
                        prevData.monthlySalaryNetTakeHome = e.target.value;
                      } else {
                        prevData.monthlySalaryNetTakeHome = '';
                      }
                      setRecommendationState({ ...recommendationState, customerDetails: prevData });
                    }}
                    inputProps={{ className: 'textInput' }}
                    fullWidth
                    placeholder="Type Monthly Salary (Net Take Home)"
                  />
                </FormControl>
              </Grid>
              <Grid item xs={4}>
                <FormControl required fullWidth className="formGroup">
                  <Typography variant="body1" className="formLabel">
                    Monthly Incentive/Bonus Income
                  </Typography>
                  <TextField
                    value={recommendationState.customerDetails.monthlyIncentiveBonusIncome}
                    onChange={(e) => {
                      const prevData = recommendationState.customerDetails;
                      if (/^\d+$/.test(e.target.value.trim())) {
                        prevData.monthlyIncentiveBonusIncome = e.target.value;
                      } else {
                        prevData.monthlyIncentiveBonusIncome = '';
                      }
                      setRecommendationState({ ...recommendationState, customerDetails: prevData });
                    }}
                    inputProps={{ className: 'textInput' }}
                    fullWidth
                    placeholder="Type Monthly Incentive/Bonus Income"
                  />
                </FormControl>
              </Grid>
            </>
          ) : (
            <>
              <Grid item xs={4}>
                <FormControl required fullWidth className="formGroup">
                  <Typography variant="body1" className="formLabel">
                    Yearly Turnover
                  </Typography>
                  <TextField
                    value={recommendationState.customerDetails.yearlyTurnover}
                    onChange={(e) => {
                      const prevData = recommendationState.customerDetails;
                      if (/^\d+$/.test(e.target.value.trim())) {
                        prevData.yearlyTurnover = e.target.value;
                      } else {
                        prevData.yearlyTurnover = '';
                      }
                      setRecommendationState({ ...recommendationState, customerDetails: prevData });
                    }}
                    inputProps={{ className: 'textInput' }}
                    fullWidth
                    placeholder="Type Yearly Turnover"
                  />
                </FormControl>
              </Grid>
              <Grid item xs={4}>
                <FormControl required fullWidth className="formGroup">
                  <Typography variant="body1" className="formLabel">
                    Yearly Net Profit
                  </Typography>
                  <TextField
                    value={recommendationState.customerDetails.yearlyNetProfit}
                    onChange={(e) => {
                      const prevData = recommendationState.customerDetails;
                      if (/^\d+$/.test(e.target.value.trim())) {
                        prevData.yearlyNetProfit = e.target.value;
                      } else {
                        prevData.yearlyNetProfit = '';
                      }
                      setRecommendationState({ ...recommendationState, customerDetails: prevData });
                    }}
                    inputProps={{ className: 'textInput' }}
                    fullWidth
                    placeholder="Type Yearly Net Profit"
                  />
                </FormControl>
              </Grid>
              <Grid item xs={4}>
                <FormControl required fullWidth className="formGroup">
                  <Typography variant="body1" className="formLabel">
                    Yearly Depreciation
                  </Typography>
                  <TextField
                    value={recommendationState.customerDetails.yearlyDepreciation}
                    onChange={(e) => {
                      const prevData = recommendationState.customerDetails;
                      if (/^\d+$/.test(e.target.value.trim())) {
                        prevData.yearlyDepreciation = e.target.value;
                      } else {
                        prevData.yearlyDepreciation = '';
                      }
                      setRecommendationState({ ...recommendationState, customerDetails: prevData });
                    }}
                    inputProps={{ className: 'textInput' }}
                    fullWidth
                    placeholder="Type Yearly Depreciation"
                  />
                </FormControl>
              </Grid>
              <Grid item xs={4}>
                <FormControl required fullWidth className="formGroup">
                  <Typography variant="body1" className="formLabel">
                    Yearly Interest
                  </Typography>
                  <TextField
                    value={recommendationState.customerDetails.yearlyInterest}
                    onChange={(e) => {
                      const prevData = recommendationState.customerDetails;
                      if (/^\d+$/.test(e.target.value.trim())) {
                        prevData.yearlyInterest = e.target.value;
                      } else {
                        prevData.yearlyInterest = '';
                      }
                      setRecommendationState({ ...recommendationState, customerDetails: prevData });
                    }}
                    inputProps={{ className: 'textInput' }}
                    fullWidth
                    placeholder="Type Yearly Interest"
                  />
                </FormControl>
              </Grid>
            </>
          )}

          <Grid item xs={4}>
            <FormControl required fullWidth className="formGroup">
              <Typography variant="body1" className="formLabel">
                Monthly Cash Income
              </Typography>
              <TextField
                value={recommendationState.customerDetails.monthlyCashIncome}
                onChange={(e) => {
                  const prevData = recommendationState.customerDetails;
                  if (/^\d+$/.test(e.target.value.trim())) {
                    prevData.monthlyCashIncome = e.target.value;
                  } else {
                    prevData.monthlyCashIncome = '';
                  }
                  setRecommendationState({ ...recommendationState, customerDetails: prevData });
                }}
                inputProps={{ className: 'textInput' }}
                fullWidth
                placeholder="Type Monthly Cash Income"
              />
            </FormControl>
          </Grid>
          <Grid item xs={4}>
            <FormControl required fullWidth className="formGroup">
              <Typography variant="body1" className="formLabel">
                Monthly Rental Income
              </Typography>
              <TextField
                value={recommendationState.customerDetails.monthlyRentalIncome}
                onChange={(e) => {
                  const prevData = recommendationState.customerDetails;
                  if (/^\d+$/.test(e.target.value.trim())) {
                    prevData.monthlyRentalIncome = e.target.value;
                  } else {
                    prevData.monthlyRentalIncome = '';
                  }
                  setRecommendationState({ ...recommendationState, customerDetails: prevData });
                }}
                inputProps={{ className: 'textInput' }}
                fullWidth
                placeholder="Type Monthly Rental Income"
              />
            </FormControl>
          </Grid>
          <Grid item xs={4}>
            <FormControl required fullWidth className="formGroup">
              <Typography variant="body1" className="formLabel">
                Monthly Interest Income
              </Typography>
              <TextField
                value={recommendationState.customerDetails.monthlyInterestIncome}
                onChange={(e) => {
                  const prevData = recommendationState.customerDetails;
                  if (/^\d+$/.test(e.target.value.trim())) {
                    prevData.monthlyInterestIncome = e.target.value;
                  } else {
                    prevData.monthlyInterestIncome = '';
                  }
                  setRecommendationState({ ...recommendationState, customerDetails: prevData });
                }}
                inputProps={{ className: 'textInput' }}
                fullWidth
                placeholder="Type Monthly Interest Income"
              />
            </FormControl>
          </Grid>
          <Grid item xs={4}>
            <FormControl required fullWidth className="formGroup">
              <Typography variant="body1" className="formLabel">
                Other Income Monthly
              </Typography>
              <TextField
                value={recommendationState.customerDetails.otherIncomeMonthly}
                onChange={(e) => {
                  const prevData = recommendationState.customerDetails;
                  if (/^\d+$/.test(e.target.value.trim())) {
                    prevData.otherIncomeMonthly = e.target.value;
                  } else {
                    prevData.otherIncomeMonthly = '';
                  }
                  setRecommendationState({ ...recommendationState, customerDetails: prevData });
                }}
                inputProps={{ className: 'textInput' }}
                fullWidth
                placeholder="Type Other Income Monthly"
              />
            </FormControl>
          </Grid>
          <Grid item xs={4}>
            <FormControl required fullWidth className="formGroup">
              <Typography variant="body1" className="formLabel">
                Total No of Loans
              </Typography>
              <TextField
                value={recommendationState.customerDetails.totalNoOfLoans}
                onChange={(e) => {
                  const prevData = recommendationState.customerDetails;
                  if (/^\d+$/.test(e.target.value.trim())) {
                    prevData.totalNoOfLoans = e.target.value;
                  } else {
                    prevData.totalNoOfLoans = '';
                  }
                  setRecommendationState({ ...recommendationState, customerDetails: prevData });
                }}
                inputProps={{ className: 'textInput' }}
                fullWidth
                placeholder="Type Total No of Loans"
              />
            </FormControl>
          </Grid>
          <Grid item xs={4}>
            <FormControl required fullWidth className="formGroup">
              <Typography variant="body1" className="formLabel">
                Total Monthly Installments
              </Typography>
              <TextField
                value={recommendationState.customerDetails.totalMonthlyInstallments}
                onChange={(e) => {
                  const prevData = recommendationState.customerDetails;
                  if (/^\d+$/.test(e.target.value.trim())) {
                    prevData.totalMonthlyInstallments = e.target.value;
                  } else {
                    prevData.totalMonthlyInstallments = '';
                  }
                  setRecommendationState({ ...recommendationState, customerDetails: prevData });
                }}
                inputProps={{ className: 'textInput' }}
                fullWidth
                placeholder="Type Total Monthly Installments"
              />
            </FormControl>
          </Grid>
        </Grid>
      </Box>

      <Typography variant="body1" className="headingLineUp headingLineUpOut">
        Credit Bureau
      </Typography>
      <Box className="viewLeadCard cardTopMinusMargin" mb={3}>
        <Grid container spacing={{ xs: 1, sm: 2, md: 3 }}>
          <Grid item xs={4}>
            <FormControl required fullWidth className="formGroup">
              <Typography variant="body1" className="formLabel">
                {JSON.parse(recommendationState?.loanDetails?.employmentType)
                  .employmentCategoryName === 'Salaried' ||
                JSON.parse(recommendationState?.loanDetails?.employmentType)
                  .employmentCategoryName === 'Business'
                  ? 'Customer'
                  : 'Company'}{' '}
                Credit Score
              </Typography>
              <TextField
                inputProps={{ className: 'textInput' }}
                fullWidth
                placeholder={`Type ${
                  JSON.parse(recommendationState?.loanDetails?.employmentType)
                    .employmentCategoryName === 'Salaried' ||
                  JSON.parse(recommendationState?.loanDetails?.employmentType)
                    .employmentCategoryName === 'Business'
                    ? 'Customer'
                    : 'Company'
                } Credit Score`}
                value={
                  JSON.parse(recommendationState?.loanDetails?.employmentType)
                    .employmentCategoryName === 'Salaried' ||
                  JSON.parse(recommendationState?.loanDetails?.employmentType)
                    .employmentCategoryName === 'Business'
                    ? recommendationState.customerDetails.customerCreditScore
                    : recommendationState.customerDetails.companyCreditScore
                }
                onChange={(e) => {
                  const prevData = recommendationState.customerDetails;
                  if (
                    JSON.parse(recommendationState?.loanDetails?.employmentType)
                      .employmentCategoryName === 'Salaried' ||
                    JSON.parse(recommendationState?.loanDetails?.employmentType)
                      .employmentCategoryName === 'Business'
                  ) {
                    prevData.customerCreditScore = e.target.value;
                  } else {
                    prevData.companyCreditScore = e.target.value;
                  }
                  setRecommendationState({ ...recommendationState, customerDetails: prevData });
                }}
              />
            </FormControl>
          </Grid>
        </Grid>
      </Box>

      <Typography variant="body1" className="headingLineUp headingLineUpOut">
        Property
      </Typography>
      <Box className="viewLeadCard cardTopMinusMargin" mb={3}>
        <Grid container spacing={{ xs: 1, sm: 2, md: 3 }}>
          <Grid item xs={4}>
            <FormControl required fullWidth className="formGroup">
              <Typography variant="body1" className="formLabel">
                Type of Property
              </Typography>
              <Select
                onChange={(e) => {
                  const prevData = recommendationState.customerDetails;
                  const inputVal = JSON.parse(e.target.value);
                  prevData.typeOfPropertyId = inputVal.typeId;
                  prevData.typeOfProperty = e.target.value;
                  setRecommendationState({ ...recommendationState, customerDetails: prevData });
                }}
                value={recommendationState.customerDetails.typeOfProperty}
                displayEmpty
                inputProps={{
                  className: `textInput customSelectBox dissabledMenu${recommendationState.customerDetails.typeOfProperty}`
                }}
              >
                <MenuItem value=" " disabled>
                  Select Type of Property
                </MenuItem>
                {recommendationState?.customerDetails?.typeOfPropertyArray?.map(
                  (itemNo, itemNoIndex) => (
                    <MenuItem key={`itemNo${itemNoIndex}`} value={JSON.stringify(itemNo)}>
                      {itemNo.typeName}
                    </MenuItem>
                  )
                )}
              </Select>
            </FormControl>
          </Grid>
          <Grid item xs={4}>
            <FormControl required fullWidth className="formGroup">
              <Typography variant="body1" className="formLabel">
                Type of Ownership
              </Typography>
              <Select
                onChange={(e) => {
                  const prevData = recommendationState.customerDetails;
                  const inputVal = JSON.parse(e.target.value);
                  prevData.typeofOwnershipId = inputVal.typeId;
                  prevData.typeofOwnership = e.target.value;
                  setRecommendationState({ ...recommendationState, customerDetails: prevData });
                }}
                value={recommendationState.customerDetails.typeofOwnership}
                displayEmpty
                inputProps={{
                  className: `textInput customSelectBox dissabledMenu${recommendationState.customerDetails.typeofOwnership}`
                }}
              >
                <MenuItem value=" " disabled>
                  Select Type of Ownership
                </MenuItem>
                {recommendationState?.customerDetails?.typeofOwnershipArray?.map(
                  (itemNo, itemNoIndex) => (
                    <MenuItem key={`itemNo${itemNoIndex}`} value={JSON.stringify(itemNo)}>
                      {itemNo.typeName}
                    </MenuItem>
                  )
                )}
              </Select>
            </FormControl>
          </Grid>
          <Grid item xs={4}>
            <FormControl required fullWidth className="formGroup">
              <Typography variant="body1" className="formLabel">
                Stage of Construction
              </Typography>
              <Select
                onChange={(e) => {
                  const prevData = recommendationState.customerDetails;
                  const inputVal = JSON.parse(e.target.value);
                  prevData.stageofConstructionId = inputVal.typeId;
                  prevData.stageofConstruction = e.target.value;
                  setRecommendationState({ ...recommendationState, customerDetails: prevData });
                }}
                value={recommendationState.customerDetails.stageofConstruction}
                displayEmpty
                inputProps={{
                  className: `textInput customSelectBox dissabledMenu${recommendationState.customerDetails.stageofConstruction}`
                }}
              >
                <MenuItem value=" " disabled>
                  Select Stage of Construction
                </MenuItem>
                {recommendationState?.customerDetails?.stageofConstructionArray?.map(
                  (itemNo, itemNoIndex) => (
                    <MenuItem key={`itemNo${itemNoIndex}`} value={JSON.stringify(itemNo)}>
                      {itemNo.typeName}
                    </MenuItem>
                  )
                )}
              </Select>
            </FormControl>
          </Grid>
          <Grid item xs={4}>
            <FormControl required fullWidth className="formGroup">
              <Typography variant="body1" className="formLabel">
                Property Age
              </Typography>
              <TextField
                inputProps={{ className: 'textInput' }}
                fullWidth
                placeholder="Type Property Age"
                value={recommendationState.customerDetails.propertyAge}
                onChange={(e) => {
                  const prevData = recommendationState.customerDetails;
                  if (/^\d+$/.test(e.target.value.trim())) {
                    prevData.propertyAge = e.target.value;
                  } else {
                    prevData.propertyAge = '';
                  }
                  setRecommendationState({ ...recommendationState, customerDetails: prevData });
                }}
              />
            </FormControl>
          </Grid>
          <Grid item xs={4}>
            <FormControl required fullWidth className="formGroup">
              <Typography variant="body1" className="formLabel">
                Location type of Property
              </Typography>
              <Select
                onChange={(e) => {
                  const prevData = recommendationState.customerDetails;
                  const inputVal = JSON.parse(e.target.value);
                  prevData.locationtypeOfPropertyId = inputVal.typeId;
                  prevData.locationtypeOfProperty = e.target.value;
                  setRecommendationState({ ...recommendationState, customerDetails: prevData });
                }}
                value={recommendationState.customerDetails.locationtypeOfProperty}
                displayEmpty
                inputProps={{
                  className: `textInput customSelectBox dissabledMenu${recommendationState.customerDetails.locationtypeOfProperty}`
                }}
              >
                <MenuItem value=" " disabled>
                  Select Location type of Property
                </MenuItem>
                {recommendationState?.customerDetails?.locationtypeOfPropertyArray?.map(
                  (itemNo, itemNoIndex) => (
                    <MenuItem key={`itemNo${itemNoIndex}`} value={JSON.stringify(itemNo)}>
                      {itemNo.typeName}
                    </MenuItem>
                  )
                )}
              </Select>
            </FormControl>
          </Grid>
          <Grid item xs={4}>
            <FormControl required fullWidth className="formGroup">
              <Typography variant="body1" className="formLabel">
                Type of Purchase
              </Typography>
              <Select
                onChange={(e) => {
                  const prevData = recommendationState.customerDetails;
                  const inputVal = JSON.parse(e.target.value);
                  prevData.typeOfPurchaseId = inputVal.typeId;
                  prevData.typeOfPurchase = e.target.value;
                  setRecommendationState({ ...recommendationState, customerDetails: prevData });
                }}
                value={recommendationState.customerDetails.typeOfPurchase}
                displayEmpty
                inputProps={{
                  className: `textInput customSelectBox dissabledMenu${recommendationState.customerDetails.typeOfPurchase}`
                }}
              >
                <MenuItem value=" " disabled>
                  Select Type of Purchase
                </MenuItem>
                {recommendationState?.customerDetails?.typeOfPurchaseArray?.map(
                  (itemNo, itemNoIndex) => (
                    <MenuItem key={`itemNo${itemNoIndex}`} value={JSON.stringify(itemNo)}>
                      {itemNo.typeName}
                    </MenuItem>
                  )
                )}
              </Select>
            </FormControl>
          </Grid>
          <Grid item xs={4}>
            <FormControl required fullWidth className="formGroup">
              <Typography variant="body1" className="formLabel">
                Project Approval Status
              </Typography>
              <Select
                onChange={(e) => {
                  const prevData = recommendationState.customerDetails;
                  prevData.projectApprovalStatus = e.target.value;
                  console.log('smmmmmmmmmm', e.target.value);
                  if (prevData.projectApprovalStatus === 'Yes') {
                    prevData.projectApprovalStatus = true;
                  } else {
                    prevData.projectApprovalStatus = false;
                  }
                  setRecommendationState({ ...recommendationState, customerDetails: prevData });
                }}
                value={
                  recommendationState.customerDetails.projectApprovalStatus === true ? 'Yes' : 'No'
                }
                displayEmpty
                inputProps={{
                  className: `textInput customSelectBox dissabledMenu${recommendationState.customerDetails.projectApprovalStatus}`
                }}
              >
                <MenuItem value=" " disabled>
                  Select Project Approval Status
                </MenuItem>
                <MenuItem value="Yes">Yes</MenuItem>
                <MenuItem value="No">No</MenuItem>
              </Select>
            </FormControl>
          </Grid>
          <Grid item xs={4}>
            <FormControl required fullWidth className="formGroup">
              <Typography variant="body1" className="formLabel">
                Name of Builder
              </Typography>
              <TextField
                inputProps={{ className: 'textInput' }}
                fullWidth
                placeholder="Type Name of Builder"
                value={recommendationState.customerDetails.nameOfBuilder}
                onChange={(e) => {
                  const prevData = recommendationState.customerDetails;
                  prevData.nameOfBuilder = e.target.value;
                  setRecommendationState({ ...recommendationState, customerDetails: prevData });
                }}
              />
            </FormControl>
          </Grid>
          <Grid item xs={4}>
            <FormControl required fullWidth className="formGroup">
              <Typography variant="body1" className="formLabel">
                Name of Approved Banks
              </Typography>
              <TextField
                inputProps={{ className: 'textInput' }}
                fullWidth
                placeholder="Type Name of Approved Banks"
                value={recommendationState.customerDetails.nameOfApprovedBanks}
                onChange={(e) => {
                  const prevData = recommendationState.customerDetails;
                  prevData.nameOfApprovedBanks = e.target.value;
                  setRecommendationState({ ...recommendationState, customerDetails: prevData });
                }}
              />
            </FormControl>
          </Grid>
        </Grid>
      </Box>
      <Typography variant="body1" className="headingLineUp headingLineUpOut">
        Property Valuation
      </Typography>
      <Box className="viewLeadCard cardTopMinusMargin">
        <Grid container spacing={{ xs: 1, sm: 2, md: 3 }}>
          <Grid item xs={4}>
            <FormControl required fullWidth className="formGroup">
              <Typography variant="body1" className="formLabel">
                Property Address
              </Typography>
              <TextField
                inputProps={{ className: 'textInput' }}
                fullWidth
                placeholder="Type Property Address"
                value={recommendationState.customerDetails.propertyAddress}
                onChange={(e) => {
                  const prevData = recommendationState.customerDetails;
                  prevData.propertyAddress = e.target.value;
                  setRecommendationState({ ...recommendationState, customerDetails: prevData });
                }}
              />
            </FormControl>
          </Grid>
          <Grid item xs={4}>
            <FormControl required fullWidth className="formGroup">
              <Typography variant="body1" className="formLabel">
                Pin Code
              </Typography>
              <TextField
                inputProps={{ className: 'textInput' }}
                fullWidth
                placeholder="Type Pin Code"
                value={recommendationState.customerDetails.pinCode}
                onChange={(e) => {
                  const prevData = recommendationState.customerDetails;
                  prevData.pinCode = e.target.value;
                  setRecommendationState({ ...recommendationState, customerDetails: prevData });
                }}
              />
            </FormControl>
          </Grid>
          <Grid item xs={4}>
            <FormControl required fullWidth className="formGroup">
              <Typography variant="body1" className="formLabel">
                Locality
              </Typography>
              <TextField
                inputProps={{ className: 'textInput' }}
                fullWidth
                placeholder="Type Locality"
                value={recommendationState.customerDetails.locality}
                onChange={(e) => {
                  const prevData = recommendationState.customerDetails;
                  prevData.locality = e.target.value;
                  setRecommendationState({ ...recommendationState, customerDetails: prevData });
                }}
              />
            </FormControl>
          </Grid>
          <Grid item xs={4}>
            <FormControl required fullWidth className="formGroup">
              <Typography variant="body1" className="formLabel">
                State
              </Typography>

              <Select
                fullWidth
                value={recommendationState.customerDetails.state}
                onChange={(e) => {
                  const prevData = recommendationState.customerDetails;
                  const inputVal = JSON.parse(e.target.value);
                  prevData.state = e.target.value;
                  prevData.stateId = inputVal.stateId;
                  prevData.city = ' ';
                  setRecommendationState({ ...recommendationState, customerDetails: prevData });
                  recommendationApiFire('cityList', prevData.stateId);
                }}
                inputProps={{
                  className: `textInput customSelectBox dissabledMenu${recommendationState.customerDetails.state}`
                }}
              >
                <MenuItem value=" " disabled>
                  Select State
                </MenuItem>

                {recommendationState?.customerDetails?.stateArray?.map(
                  (stateArrayItem, stateArrayItemIndex) => (
                    <MenuItem
                      key={`employmentTypeItem${stateArrayItemIndex}`}
                      value={JSON.stringify(stateArrayItem)}
                    >
                      {stateArrayItem.stateName}
                    </MenuItem>
                  )
                )}
              </Select>
            </FormControl>
          </Grid>
          <Grid item xs={4}>
            <FormControl required fullWidth className="formGroup">
              <Typography variant="body1" className="formLabel">
                City
              </Typography>

              <Select
                fullWidth
                value={recommendationState.customerDetails.city}
                onChange={(e) => {
                  const prevData = recommendationState.customerDetails;
                  const inputVal = JSON.parse(e.target.value);
                  prevData.city = e.target.value;
                  prevData.cityId = inputVal.cityId;
                  setRecommendationState({ ...recommendationState, customerDetails: prevData });
                }}
                inputProps={{
                  className: `textInput customSelectBox dissabledMenu${recommendationState.customerDetails.city}`
                }}
              >
                <MenuItem value=" " disabled>
                  Select City
                </MenuItem>

                {recommendationState?.customerDetails?.cityArray?.map(
                  (cityArrayItem, cityArrayItemIndex) => (
                    <MenuItem
                      key={`employmentTypeItem${cityArrayItemIndex}`}
                      value={JSON.stringify(cityArrayItem)}
                    >
                      {cityArrayItem.cityName}
                    </MenuItem>
                  )
                )}
              </Select>
            </FormControl>
          </Grid>
          <Grid item xs={4}>
            <FormControl required fullWidth className="formGroup">
              <Typography variant="body1" className="formLabel">
                District
              </Typography>
              <TextField
                inputProps={{ className: 'textInput' }}
                fullWidth
                placeholder="Type District"
                value={recommendationState.customerDetails.district}
                onChange={(e) => {
                  const prevData = recommendationState.customerDetails;
                  prevData.district = e.target.value;
                  setRecommendationState({ ...recommendationState, customerDetails: prevData });
                }}
              />
            </FormControl>
          </Grid>

          <Grid item xs={4}>
            <FormControl required fullWidth className="formGroup">
              <Typography variant="body1" className="formLabel">
                99acres
              </Typography>
              <TextField
                inputProps={{ className: 'textInput' }}
                fullWidth
                placeholder="Type 99acres"
                value={recommendationState.customerDetails.acres}
                onChange={(e) => {
                  const prevData = recommendationState.customerDetails;
                  prevData.acres = e.target.value;
                  setRecommendationState({ ...recommendationState, customerDetails: prevData });
                }}
              />
            </FormControl>
          </Grid>
          <Grid item xs={4}>
            <FormControl required fullWidth className="formGroup">
              <Typography variant="body1" className="formLabel">
                Magic Bricks Value
              </Typography>
              <TextField
                inputProps={{ className: 'textInput' }}
                fullWidth
                placeholder="Type Magic Bricks Value"
                value={recommendationState.customerDetails.magicBricksValue}
                onChange={(e) => {
                  const prevData = recommendationState.customerDetails;
                  prevData.magicBricksValue = e.target.value;
                  setRecommendationState({ ...recommendationState, customerDetails: prevData });
                }}
              />
            </FormControl>
          </Grid>
          <Grid item xs={4}>
            <FormControl required fullWidth className="formGroup">
              <Typography variant="body1" className="formLabel">
                Makaan.com Valuation
              </Typography>
              <TextField
                inputProps={{ className: 'textInput' }}
                fullWidth
                placeholder="Type Makaan.com Valuation"
                value={recommendationState.customerDetails.makaanComValuation}
                onChange={(e) => {
                  const prevData = recommendationState.customerDetails;
                  prevData.makaanComValuation = e.target.value;
                  setRecommendationState({ ...recommendationState, customerDetails: prevData });
                }}
              />
            </FormControl>
          </Grid>
          <Grid item xs={4}>
            <FormControl required fullWidth className="formGroup">
              <Typography variant="body1" className="formLabel">
                Housing
              </Typography>
              <TextField
                inputProps={{ className: 'textInput' }}
                fullWidth
                placeholder="Type Housing"
                value={recommendationState.customerDetails.housing}
                onChange={(e) => {
                  const prevData = recommendationState.customerDetails;
                  prevData.housing = e.target.value;
                  setRecommendationState({ ...recommendationState, customerDetails: prevData });
                }}
              />
            </FormControl>
          </Grid>
          <Grid item xs={4}>
            <FormControl required fullWidth className="formGroup">
              <Typography variant="body1" className="formLabel">
                Registar data valuation
              </Typography>
              <TextField
                inputProps={{ className: 'textInput' }}
                fullWidth
                placeholder="Type Registar data valuation"
                value={recommendationState.customerDetails.registarDataValuation}
                onChange={(e) => {
                  const prevData = recommendationState.customerDetails;
                  prevData.registarDataValuation = e.target.value;
                  setRecommendationState({ ...recommendationState, customerDetails: prevData });
                }}
              />
            </FormControl>
          </Grid>
          <Grid item xs={4}>
            <FormControl required fullWidth className="formGroup">
              <Typography variant="body1" className="formLabel">
                Property value 2
              </Typography>
              <TextField
                inputProps={{ className: 'textInput' }}
                fullWidth
                placeholder="Type Property value 2"
                value={recommendationState.customerDetails.propertyValue2}
                onChange={(e) => {
                  const prevData = recommendationState.customerDetails;
                  prevData.propertyValue2 = e.target.value;
                  setRecommendationState({ ...recommendationState, customerDetails: prevData });
                }}
              />
            </FormControl>
          </Grid>
        </Grid>
      </Box>
      <Box sx={{ display: 'flex', paddingTop: '1.5rem' }}>
        <Button
          onClick={() => handleNextBackFinish('onlyBack')}
          startIcon={<HiOutlineArrowNarrowLeft />}
          className="mainBtn previousBtn"
        >
          Back
        </Button>
        <Button
          onClick={() => formValidation('customerDetails')}
          className="mainBtn nextBtn"
          endIcon={<HiOutlineArrowNarrowRight />}
          variant="contained"
        >
          Next
        </Button>
      </Box>
    </>
  );
}

function Step3Content({
  handleNextBackFinish,
  recommendationState,
  setRecommendationState,
  formValidation,
  recommendationApiFire
}) {
  const [selectGender, setSelectGender] = useState(' ');
  const [selectMaritalStatus, setSelectMaritalStatus] = useState(' ');
  const [selectOrganizationType, setSelectOrganizationType] = useState(' ');
  const [selectSalaryType, setSelectSalaryType] = useState(' ');
  const [selectCoApplicantEmpStatus, setSelectCoApplicantEmpStatus] = useState(' ');
  const [selectCoApplicantEmpType, setSelectCoApplicantEmpType] = useState('Salaried');
  const [selectCoApplicantEmpSubType, setSelectCoApplicantEmpSubType] = useState('Salaried');
  const [selectPropertyType, setSelectPropertyType] = useState(' ');
  const [selectOwnershipType, setSelectOwnershipType] = useState(' ');
  const [selectStageConstruction, setSelectStageConstruction] = useState(' ');
  const [selectLocationType, setSelectLocationType] = useState(' ');
  const [selectPurchaseType, setSelectPurchaseType] = useState(' ');
  const [selectProjectStatus, setSelectProjectStatus] = useState(' ');
  const [selectOrgnization, setSelectOrgnization] = useState(' ');
  const [selectBusinessProofRequired, setSelectBusinessProofRequired] = useState(' ');
  const [selectProfession, setSelectProfession] = useState(' ');
  const [deleteConfirm, setDeleteConfirm] = useState(false);
  const [fullWidth, setFullWidth] = useState(true);
  const [maxWidth, setMaxWidth] = useState('md');

  return (
    <>
      <Box className="viewLeadCard" mb={3}>
        <Grid container spacing={3}>
          <Grid item xs={4}>
            <FormControl required fullWidth className="formGroup">
              <Typography variant="body2" className="formLabel">
                Co Applicant Employment Type
              </Typography>
              <Select
                onChange={(e) => {
                  const prevData = recommendationState.coApplicantDetails;
                  const inputVal = JSON.parse(e.target.value);
                  prevData.coApplicantEmploymentType = e.target.value;
                  prevData.coApplicantEmploymentTypeId = inputVal.employmentCategoryId;
                  prevData.coApplicantEmploymentSubType = ' ';
                  setRecommendationState({
                    ...recommendationState,
                    coApplicantDetails: prevData
                  });
                  recommendationApiFire('employmentSubType', prevData.coApplicantEmploymentTypeId);
                }}
                value={recommendationState.coApplicantDetails.coApplicantEmploymentType}
                displayEmpty
                inputProps={{
                  className: `textInput customSelectBox dissabledMenu${recommendationState.coApplicantDetails.coApplicantEmploymentType}`
                }}
              >
                <MenuItem value=" " disabled>
                  Select Co-Applicant Employment Type
                </MenuItem>
                {recommendationState.coApplicantDetails.coApplicantEmploymentTypeArray.map(
                  (employmentTypeItem, employmentTypeIndex) => (
                    <MenuItem
                      key={`employmentTypeItem${employmentTypeIndex}`}
                      value={JSON.stringify(employmentTypeItem)}
                    >
                      {employmentTypeItem.employmentCategoryName}
                    </MenuItem>
                  )
                )}
              </Select>
            </FormControl>
          </Grid>
          <Grid item xs={4}>
            <FormControl required fullWidth className="formGroup">
              <Typography variant="body2" className="formLabel">
                Co Applicant Employment Sub Type
              </Typography>
              <Select
                onChange={(e) => {
                  const prevData = recommendationState.coApplicantDetails;
                  const inputVal = JSON.parse(e.target.value);
                  prevData.coApplicantEmploymentSubType = e.target.value;
                  prevData.coApplicantEmploymentSubTypeId = inputVal.employmentSubcategoryId;
                  setRecommendationState({ ...recommendationState, coApplicantDetails: prevData });
                }}
                value={recommendationState.coApplicantDetails.coApplicantEmploymentSubType}
                displayEmpty
                inputProps={{
                  className: `textInput customSelectBox dissabledMenu${recommendationState.coApplicantDetails.coApplicantEmploymentSubType}`
                }}
              >
                <MenuItem value=" " disabled>
                  Select Co-Applicant Employment Sub Type
                </MenuItem>

                {recommendationState.coApplicantDetails.coApplicantEmploymentSubTypeArray.map(
                  (employmentSubTypeItem, employmentSubTypeIndex) => (
                    <MenuItem
                      key={`employmentSubTypeItem${employmentSubTypeIndex}`}
                      value={JSON.stringify(employmentSubTypeItem)}
                    >
                      {employmentSubTypeItem.employmentSubcategoryName}
                    </MenuItem>
                  )
                )}
              </Select>
            </FormControl>
          </Grid>
        </Grid>
      </Box>

      {recommendationState?.coApplicantDetails?.coApplicantEmploymentType !== ' ' ? (
        JSON.parse(recommendationState?.coApplicantDetails?.coApplicantEmploymentType)
          .employmentCategoryName === 'Salaried' ||
        JSON.parse(recommendationState?.coApplicantDetails?.coApplicantEmploymentType)
          .employmentCategoryName === 'Pensioner' ||
        JSON.parse(recommendationState?.coApplicantDetails?.coApplicantEmploymentType)
          .employmentCategoryName === 'Business' ? (
          <>
            <Typography variant="body1" className="headingLineUp headingLineUpOut">
              Co-Applicant Details
            </Typography>
            <Box className="viewLeadCard cardTopMinusMargin" mb={3}>
              <Grid container spacing={{ xs: 1, sm: 2, md: 3 }}>
                <Grid item xs={4}>
                  <FormControl required fullWidth className="formGroup">
                    <Typography variant="body1" className="formLabel">
                      Type of Salary
                    </Typography>
                    <Select
                      onChange={(e) => {
                        const prevData = recommendationState.coApplicantDetails;
                        const inputVal = JSON.parse(e.target.value);
                        prevData.typeOfSalaryId = inputVal.typeId;
                        prevData.typeOfSalary = e.target.value;
                        setRecommendationState({
                          ...recommendationState,
                          coApplicantDetails: prevData
                        });
                      }}
                      value={recommendationState.coApplicantDetails.typeOfSalary}
                      displayEmpty
                      inputProps={{
                        className: `textInput customSelectBox dissabledMenu${recommendationState.coApplicantDetails.typeOfSalary}`
                      }}
                    >
                      <MenuItem value=" " disabled>
                        Select Type of Salary
                      </MenuItem>
                      {recommendationState.coApplicantDetails.typeOfSalaryArray.map(
                        (itemNo, itemNoIndex) => (
                          <MenuItem key={`itemNo${itemNoIndex}`} value={JSON.stringify(itemNo)}>
                            {itemNo.typeName}
                          </MenuItem>
                        )
                      )}
                    </Select>
                  </FormControl>
                </Grid>
                <Grid item xs={4}>
                  <FormControl required fullWidth className="formGroup">
                    <Typography variant="body1" className="formLabel">
                      Gross Salary Per Annum
                    </Typography>
                    <TextField
                      inputProps={{ className: 'textInput' }}
                      fullWidth
                      placeholder="Type Gross Salary Per Annum"
                      value={recommendationState.coApplicantDetails.grossSalaryPerAnnum}
                      onChange={(e) => {
                        const prevData = recommendationState.coApplicantDetails;
                        if (/^\d+$/.test(e.target.value.trim())) {
                          prevData.grossSalaryPerAnnum = e.target.value;
                        } else {
                          prevData.grossSalaryPerAnnum = '';
                        }
                        setRecommendationState({
                          ...recommendationState,
                          coApplicantDetails: prevData
                        });
                      }}
                    />
                  </FormControl>
                </Grid>
                <Grid item xs={4}>
                  <FormControl required fullWidth className="formGroup">
                    <Typography variant="body1" className="formLabel">
                      Monthly Salary (Net Take Home)
                    </Typography>
                    <TextField
                      inputProps={{ className: 'textInput' }}
                      fullWidth
                      placeholder="Type Monthly Salary (Net Take Home)"
                      value={recommendationState.coApplicantDetails.monthlySalaryNetTakeHome}
                      onChange={(e) => {
                        const prevData = recommendationState.coApplicantDetails;
                        if (/^\d+$/.test(e.target.value.trim())) {
                          prevData.monthlySalaryNetTakeHome = e.target.value;
                        } else {
                          prevData.monthlySalaryNetTakeHome = '';
                        }
                        setRecommendationState({
                          ...recommendationState,
                          coApplicantDetails: prevData
                        });
                      }}
                    />
                  </FormControl>
                </Grid>
                <Grid item xs={4}>
                  <FormControl required fullWidth className="formGroup">
                    <Typography variant="body1" className="formLabel">
                      Monthly Incentive/Bonus Income
                    </Typography>
                    <TextField
                      inputProps={{ className: 'textInput' }}
                      fullWidth
                      placeholder="Type Monthly Incentive/Bonus Income"
                      value={recommendationState.coApplicantDetails.monthlyIncentiveBonusIncome}
                      onChange={(e) => {
                        const prevData = recommendationState.coApplicantDetails;
                        if (/^\d+$/.test(e.target.value.trim())) {
                          prevData.monthlyIncentiveBonusIncome = e.target.value;
                        } else {
                          prevData.monthlyIncentiveBonusIncome = '';
                        }
                        setRecommendationState({
                          ...recommendationState,
                          coApplicantDetails: prevData
                        });
                      }}
                    />
                  </FormControl>
                </Grid>
                <Grid item xs={4}>
                  <FormControl required fullWidth className="formGroup">
                    <Typography variant="body1" className="formLabel">
                      Monthly Cash Income
                    </Typography>
                    <TextField
                      inputProps={{ className: 'textInput' }}
                      fullWidth
                      placeholder="Type Monthly Cash Income"
                      value={recommendationState.coApplicantDetails.monthlyCashIncome}
                      onChange={(e) => {
                        const prevData = recommendationState.coApplicantDetails;
                        if (/^\d+$/.test(e.target.value.trim())) {
                          prevData.monthlyCashIncome = e.target.value;
                        } else {
                          prevData.monthlyCashIncome = '';
                        }
                        setRecommendationState({
                          ...recommendationState,
                          coApplicantDetails: prevData
                        });
                      }}
                    />
                  </FormControl>
                </Grid>
                <Grid item xs={4}>
                  <FormControl required fullWidth className="formGroup">
                    <Typography variant="body1" className="formLabel">
                      Monthly Rental Income
                    </Typography>
                    <TextField
                      inputProps={{ className: 'textInput' }}
                      fullWidth
                      placeholder="Type Monthly Rental Income"
                      value={recommendationState.coApplicantDetails.monthlyRentalIncome}
                      onChange={(e) => {
                        const prevData = recommendationState.coApplicantDetails;
                        if (/^\d+$/.test(e.target.value.trim())) {
                          prevData.monthlyRentalIncome = e.target.value;
                        } else {
                          prevData.monthlyRentalIncome = '';
                        }
                        setRecommendationState({
                          ...recommendationState,
                          coApplicantDetails: prevData
                        });
                      }}
                    />
                  </FormControl>
                </Grid>
                <Grid item xs={4}>
                  <FormControl required fullWidth className="formGroup">
                    <Typography variant="body1" className="formLabel">
                      Monthly Interest Income
                    </Typography>
                    <TextField
                      inputProps={{ className: 'textInput' }}
                      fullWidth
                      placeholder="Type Monthly Interest Income"
                      value={recommendationState.coApplicantDetails.monthlyInterestIncome}
                      onChange={(e) => {
                        const prevData = recommendationState.coApplicantDetails;
                        if (/^\d+$/.test(e.target.value.trim())) {
                          prevData.monthlyInterestIncome = e.target.value;
                        } else {
                          prevData.monthlyInterestIncome = '';
                        }
                        setRecommendationState({
                          ...recommendationState,
                          coApplicantDetails: prevData
                        });
                      }}
                    />
                  </FormControl>
                </Grid>
                <Grid item xs={4}>
                  <FormControl required fullWidth className="formGroup">
                    <Typography variant="body1" className="formLabel">
                      Other Income Monthly
                    </Typography>
                    <TextField
                      inputProps={{ className: 'textInput' }}
                      fullWidth
                      placeholder="Type Other Income Monthly"
                      value={recommendationState.coApplicantDetails.otherIncomeMonthly}
                      onChange={(e) => {
                        const prevData = recommendationState.coApplicantDetails;
                        if (/^\d+$/.test(e.target.value.trim())) {
                          prevData.otherIncomeMonthly = e.target.value;
                        } else {
                          prevData.otherIncomeMonthly = '';
                        }
                        setRecommendationState({
                          ...recommendationState,
                          coApplicantDetails: prevData
                        });
                      }}
                    />
                  </FormControl>
                </Grid>
                <Grid item xs={4}>
                  <FormControl required fullWidth className="formGroup">
                    <Typography variant="body1" className="formLabel">
                      Total No of Loans
                    </Typography>
                    <TextField
                      inputProps={{ className: 'textInput' }}
                      fullWidth
                      placeholder="Type Total No of Loans"
                      value={recommendationState.coApplicantDetails.totalNoOfLoans}
                      onChange={(e) => {
                        const prevData = recommendationState.coApplicantDetails;
                        if (/^\d+$/.test(e.target.value.trim())) {
                          prevData.totalNoOfLoans = e.target.value;
                        } else {
                          prevData.totalNoOfLoans = '';
                        }
                        setRecommendationState({
                          ...recommendationState,
                          coApplicantDetails: prevData
                        });
                      }}
                    />
                  </FormControl>
                </Grid>
                <Grid item xs={4}>
                  <FormControl required fullWidth className="formGroup">
                    <Typography variant="body1" className="formLabel">
                      Total Monthly Installments
                    </Typography>
                    <TextField
                      inputProps={{ className: 'textInput' }}
                      fullWidth
                      placeholder="Type Total Monthly Installments"
                      value={recommendationState.coApplicantDetails.totalMonthlyInstallments}
                      onChange={(e) => {
                        const prevData = recommendationState.coApplicantDetails;
                        if (/^\d+$/.test(e.target.value.trim())) {
                          prevData.totalMonthlyInstallments = e.target.value;
                        } else {
                          prevData.totalMonthlyInstallments = '';
                        }
                        setRecommendationState({
                          ...recommendationState,
                          coApplicantDetails: prevData
                        });
                      }}
                    />
                  </FormControl>
                </Grid>
                <Grid item xs={4}>
                  <FormControl required fullWidth className="formGroup">
                    <Typography variant="body1" className="formLabel">
                      Total Job Continuity in Months
                    </Typography>
                    <TextField
                      onChange={(e) => {
                        const prevData = recommendationState.coApplicantDetails;
                        if (/^\d+$/.test(e.target.value.trim())) {
                          prevData.coapplicantJobContinuity = e.target.value;
                        } else {
                          prevData.coapplicantJobContinuity = '';
                        }
                        setRecommendationState({
                          ...recommendationState,
                          coApplicantDetails: prevData
                        });
                      }}
                      value={recommendationState.coApplicantDetails.coapplicantJobContinuity}
                      inputProps={{ className: 'textInput' }}
                      fullWidth
                      placeholder="Type Total Job Continuity in Months"
                    />
                  </FormControl>
                </Grid>
                <Grid item xs={4}>
                  <FormControl required fullWidth className="formGroup">
                    <Typography variant="body1" className="formLabel">
                      Date of Birth
                    </Typography>
                    <TextField
                      value={recommendationState.coApplicantDetails.coApplicantDateOfBirth}
                      onChange={(e) => {
                        const prevData = recommendationState.coApplicantDetails;
                        prevData.coApplicantDateOfBirth = e.target.value;
                        setRecommendationState({
                          ...recommendationState,
                          coApplicantDetails: prevData
                        });
                      }}
                      type="date"
                      inputProps={{ className: 'textInput' }}
                      fullWidth
                      placeholder="Select Date"
                    />
                  </FormControl>
                </Grid>
              </Grid>
            </Box>
          </>
        ) : recommendationState?.coApplicantDetails?.coApplicantEmploymentType !== ' ' ? (
          JSON.parse(recommendationState?.coApplicantDetails?.coApplicantEmploymentType)
            .employmentCategoryName === 'Self Employed' ||
          JSON.parse(recommendationState?.coApplicantDetails?.coApplicantEmploymentType)
            .employmentCategoryName === 'Business' ? (
            <>
              <Typography variant="body1" className="headingLineUp headingLineUpOut">
                Co Applicant Details
              </Typography>
              <Box className="viewLeadCard cardTopMinusMargin" mb={3}>
                <Grid container spacing={{ xs: 1, sm: 2, md: 3 }}>
                  <Grid item xs={4}>
                    <FormControl required fullWidth className="formGroup">
                      <Typography variant="body1" className="formLabel">
                        Yearly Turnover
                      </Typography>
                      <TextField
                        inputProps={{ className: 'textInput' }}
                        fullWidth
                        placeholder="Type Yearly Turnover"
                        value={recommendationState.coApplicantDetails.yearlyTurnover}
                        onChange={(e) => {
                          const prevData = recommendationState.coApplicantDetails;
                          prevData.yearlyTurnover = e.target.value;
                          setRecommendationState({
                            ...recommendationState,
                            coApplicantDetails: prevData
                          });
                        }}
                      />
                    </FormControl>
                  </Grid>
                  <Grid item xs={4}>
                    <FormControl required fullWidth className="formGroup">
                      <Typography variant="body1" className="formLabel">
                        Yearly Net Profit
                      </Typography>
                      <TextField
                        inputProps={{ className: 'textInput' }}
                        fullWidth
                        placeholder="Type Yearly Net Profit"
                        value={recommendationState.coApplicantDetails.yearlyNetProfit}
                        onChange={(e) => {
                          const prevData = recommendationState.coApplicantDetails;
                          prevData.yearlyNetProfit = e.target.value;
                          setRecommendationState({
                            ...recommendationState,
                            coApplicantDetails: prevData
                          });
                        }}
                      />
                    </FormControl>
                  </Grid>
                  <Grid item xs={4}>
                    <FormControl required fullWidth className="formGroup">
                      <Typography variant="body1" className="formLabel">
                        Yearly Depreciation
                      </Typography>
                      <TextField
                        inputProps={{ className: 'textInput' }}
                        fullWidth
                        placeholder="Type Yearly Depreciation"
                        value={recommendationState.coApplicantDetails.yearlyDepreciation}
                        onChange={(e) => {
                          const prevData = recommendationState.coApplicantDetails;
                          prevData.yearlyDepreciation = e.target.value;
                          setRecommendationState({
                            ...recommendationState,
                            coApplicantDetails: prevData
                          });
                        }}
                      />
                    </FormControl>
                  </Grid>
                  <Grid item xs={4}>
                    <FormControl required fullWidth className="formGroup">
                      <Typography variant="body1" className="formLabel">
                        Yearly Interest
                      </Typography>
                      <TextField
                        inputProps={{ className: 'textInput' }}
                        fullWidth
                        placeholder="Type Yearly Interest"
                        value={recommendationState.coApplicantDetails.yearlyInterest}
                        onChange={(e) => {
                          const prevData = recommendationState.coApplicantDetails;
                          prevData.yearlyInterest = e.target.value;
                          setRecommendationState({
                            ...recommendationState,
                            coApplicantDetails: prevData
                          });
                        }}
                      />
                    </FormControl>
                  </Grid>

                  <Grid item xs={4}>
                    <FormControl required fullWidth className="formGroup">
                      <Typography variant="body1" className="formLabel">
                        Monthly Cash Income
                      </Typography>
                      <TextField
                        inputProps={{ className: 'textInput' }}
                        fullWidth
                        placeholder="Type Monthly Cash Income"
                        value={recommendationState.coApplicantDetails.monthlyCashIncome}
                        onChange={(e) => {
                          const prevData = recommendationState.coApplicantDetails;
                          if (/^\d+$/.test(e.target.value.trim())) {
                            prevData.monthlyCashIncome = e.target.value;
                          } else {
                            prevData.monthlyCashIncome = '';
                          }
                          setRecommendationState({
                            ...recommendationState,
                            coApplicantDetails: prevData
                          });
                        }}
                      />
                    </FormControl>
                  </Grid>
                  <Grid item xs={4}>
                    <FormControl required fullWidth className="formGroup">
                      <Typography variant="body1" className="formLabel">
                        Monthly Rental Income
                      </Typography>
                      <TextField
                        inputProps={{ className: 'textInput' }}
                        fullWidth
                        placeholder="Type Monthly Rental Income"
                        value={recommendationState.coApplicantDetails.monthlyRentalIncome}
                        onChange={(e) => {
                          const prevData = recommendationState.coApplicantDetails;
                          if (/^\d+$/.test(e.target.value.trim())) {
                            prevData.monthlyRentalIncome = e.target.value;
                          } else {
                            prevData.monthlyRentalIncome = '';
                          }
                          setRecommendationState({
                            ...recommendationState,
                            coApplicantDetails: prevData
                          });
                        }}
                      />
                    </FormControl>
                  </Grid>
                  <Grid item xs={4}>
                    <FormControl required fullWidth className="formGroup">
                      <Typography variant="body1" className="formLabel">
                        Monthly Interest Income
                      </Typography>
                      <TextField
                        inputProps={{ className: 'textInput' }}
                        fullWidth
                        placeholder="Type Monthly Interest Income"
                        value={recommendationState.coApplicantDetails.monthlyInterestIncome}
                        onChange={(e) => {
                          const prevData = recommendationState.coApplicantDetails;
                          if (/^\d+$/.test(e.target.value.trim())) {
                            prevData.monthlyInterestIncome = e.target.value;
                          } else {
                            prevData.monthlyInterestIncome = '';
                          }
                          setRecommendationState({
                            ...recommendationState,
                            coApplicantDetails: prevData
                          });
                        }}
                      />
                    </FormControl>
                  </Grid>
                  <Grid item xs={4}>
                    <FormControl required fullWidth className="formGroup">
                      <Typography variant="body1" className="formLabel">
                        Other Income Monthly
                      </Typography>
                      <TextField
                        inputProps={{ className: 'textInput' }}
                        fullWidth
                        placeholder="Type Other Income Monthly"
                        value={recommendationState.coApplicantDetails.otherIncomeMonthly}
                        onChange={(e) => {
                          const prevData = recommendationState.coApplicantDetails;
                          if (/^\d+$/.test(e.target.value.trim())) {
                            prevData.otherIncomeMonthly = e.target.value;
                          } else {
                            prevData.otherIncomeMonthly = '';
                          }
                          setRecommendationState({
                            ...recommendationState,
                            coApplicantDetails: prevData
                          });
                        }}
                      />
                    </FormControl>
                  </Grid>
                  <Grid item xs={4}>
                    <FormControl required fullWidth className="formGroup">
                      <Typography variant="body1" className="formLabel">
                        Total No of Loans
                      </Typography>
                      <TextField
                        inputProps={{ className: 'textInput' }}
                        fullWidth
                        placeholder="Type Total No of Loans"
                        value={recommendationState.coApplicantDetails.totalNoOfLoans}
                        onChange={(e) => {
                          const prevData = recommendationState.coApplicantDetails;
                          if (/^\d+$/.test(e.target.value.trim())) {
                            prevData.totalNoOfLoans = e.target.value;
                          } else {
                            prevData.totalNoOfLoans = '';
                          }
                          setRecommendationState({
                            ...recommendationState,
                            coApplicantDetails: prevData
                          });
                        }}
                      />
                    </FormControl>
                  </Grid>
                  <Grid item xs={4}>
                    <FormControl required fullWidth className="formGroup">
                      <Typography variant="body1" className="formLabel">
                        Total Monthly Installments
                      </Typography>
                      <TextField
                        inputProps={{ className: 'textInput' }}
                        fullWidth
                        placeholder="Type Total Monthly Installments"
                        value={recommendationState.coApplicantDetails.totalMonthlyInstallments}
                        onChange={(e) => {
                          const prevData = recommendationState.coApplicantDetails;
                          if (/^\d+$/.test(e.target.value.trim())) {
                            prevData.totalMonthlyInstallments = e.target.value;
                          } else {
                            prevData.totalMonthlyInstallments = '';
                          }
                          setRecommendationState({
                            ...recommendationState,
                            coApplicantDetails: prevData
                          });
                        }}
                      />
                    </FormControl>
                  </Grid>
                </Grid>
              </Box>
            </>
          ) : (
            ''
          )
        ) : (
          ''
        )
      ) : (
        ''
      )}

      {recommendationState?.coApplicantDetails?.coApplicantEmploymentType !== ' ' ? (
        JSON.parse(recommendationState?.coApplicantDetails?.coApplicantEmploymentType)
          .employmentCategoryName === 'Salaried' ||
        JSON.parse(recommendationState?.coApplicantDetails?.coApplicantEmploymentType)
          .employmentCategoryName === 'Pensioner' ? (
          <>
            <Typography variant="body1" className="headingLineUp headingLineUpOut">
              Credit Bureau
            </Typography>
            <Box className="viewLeadCard cardTopMinusMargin">
              <Grid container spacing={{ xs: 1, sm: 2, md: 3 }}>
                <Grid item xs={4}>
                  <FormControl required fullWidth className="formGroup">
                    <Typography variant="body1" className="formLabel">
                      Co Applicant Credit Score
                    </Typography>
                    <TextField
                      inputProps={{ className: 'textInput' }}
                      fullWidth
                      placeholder="Type Co Applicant Credit Score"
                      value={recommendationState.coApplicantDetails.coApplicantCreditScore}
                      onChange={(e) => {
                        const prevData = recommendationState.coApplicantDetails;
                        if (/^\d+$/.test(e.target.value.trim())) {
                          prevData.coApplicantCreditScore = e.target.value;
                        } else {
                          prevData.coApplicantCreditScore = '';
                        }
                        setRecommendationState({
                          ...recommendationState,
                          coApplicantDetails: prevData
                        });
                      }}
                    />
                  </FormControl>
                </Grid>
              </Grid>
            </Box>
          </>
        ) : recommendationState?.coApplicantDetails?.coApplicantEmploymentType !== ' ' ? (
          JSON.parse(recommendationState?.coApplicantDetails?.coApplicantEmploymentType)
            .employmentCategoryName === 'Self Employed' ||
          JSON.parse(recommendationState?.coApplicantDetails?.coApplicantEmploymentType)
            .employmentCategoryName === 'Business' ? (
            <>
              <Typography variant="body1" className="headingLineUp headingLineUpOut">
                Credit Bureau
              </Typography>
              <Box className="viewLeadCard cardTopMinusMargin">
                <Grid container spacing={{ xs: 1, sm: 2, md: 3 }}>
                  <Grid item xs={4}>
                    <FormControl required fullWidth className="formGroup">
                      <Typography variant="body1" className="formLabel">
                        Company Credit Score
                      </Typography>
                      <TextField
                        inputProps={{ className: 'textInput' }}
                        fullWidth
                        placeholder="Type Company Credit Score"
                        value={recommendationState.coApplicantDetails.coApplicantCompanyCreditScore}
                        onChange={(e) => {
                          const prevData = recommendationState.coApplicantDetails;
                          if (/^\d+$/.test(e.target.value.trim())) {
                            prevData.coApplicantCompanyCreditScore = e.target.value;
                          } else {
                            prevData.coApplicantCompanyCreditScore = '';
                          }
                          setRecommendationState({
                            ...recommendationState,
                            coApplicantDetails: prevData
                          });
                        }}
                      />
                    </FormControl>
                  </Grid>
                  <Grid item xs={4}>
                    <FormControl required fullWidth className="formGroup">
                      <Typography variant="body1" className="formLabel">
                        Co Applicant Credit Score
                      </Typography>
                      <TextField
                        inputProps={{ className: 'textInput' }}
                        fullWidth
                        placeholder="Type Co Applicant Credit Score"
                        value={recommendationState.coApplicantDetails.coApplicantCreditScore}
                        onChange={(e) => {
                          const prevData = recommendationState.coApplicantDetails;
                          if (/^\d+$/.test(e.target.value.trim())) {
                            prevData.coApplicantCreditScore = e.target.value;
                          } else {
                            prevData.coApplicantCreditScore = '';
                          }
                          setRecommendationState({
                            ...recommendationState,
                            coApplicantDetails: prevData
                          });
                        }}
                      />
                    </FormControl>
                  </Grid>
                </Grid>
              </Box>
            </>
          ) : (
            ''
          )
        ) : (
          ''
        )
      ) : (
        ''
      )}

      <Box sx={{ display: 'flex', paddingTop: '1.5rem' }}>
        <Button
          onClick={() => handleNextBackFinish('onlyBack')}
          startIcon={<HiOutlineArrowNarrowLeft />}
          className="mainBtn previousBtn"
        >
          Back
        </Button>
        <Button
          onClick={() => formValidation('coApplicantDetails')}
          className="mainBtn nextBtn"
          endIcon={<HiOutlineArrowNarrowRight />}
          variant="contained"
        >
          Next
        </Button>
      </Box>
    </>
  );
}

function Step4Content({ handleNextBackFinish, getrecomdationDataList }) {
  return (
    <Box>
      <RecommendationResult addCase="yes" getrecomdationDataList={getrecomdationDataList} />
      <Box sx={{ display: 'flex', paddingTop: '1.5rem' }}>
        <Button
          onClick={() => handleNextBackFinish('onlyBack')}
          startIcon={<HiOutlineArrowNarrowLeft />}
          className="mainBtn previousBtn"
        >
          Back
        </Button>
        <Button
          endIcon={<HiOutlineArrowNarrowRight />}
          onClick={() => handleNextBackFinish('finish')}
          className="mainBtn nextBtn"
        >
          Finish
        </Button>
      </Box>
    </Box>
  );
}

export default LoanApplication;
